  // Piranha Gumshield Customiser — Toolbar-based selection actions (no corner handles)
(function () {
  'use strict';


    // -----------------------------
  // Capture URL Parameters for Affiliate Tracking
  // -----------------------------
  const originalUrlParams = new URLSearchParams(window.location.search);
  const affiliateParams = {};
  originalUrlParams.forEach((value, key) => {
    affiliateParams[key] = value;
  });

  // -----------------------------
  // UTF-8–safe SVG → base64 (replaces deprecated btoa(unescape(...)))
  // -----------------------------
  function _piranhaUtf8ToBase64(str) {
    var bytes = new TextEncoder().encode(str);
    var binary = '';
    for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
  }

  // -----------------------------
  // Toast notifications (replaces alert())
  // -----------------------------
  let _piranhaToastTimer = 0;
  function showPiranhaToast(message, durationMs) {
    durationMs = durationMs || 3500;
    let el = document.querySelector('.piranha-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'piranha-toast';
      document.body.appendChild(el);
    }
    clearTimeout(_piranhaToastTimer);
    el.textContent = message;
    el.classList.remove('visible');
    void el.offsetHeight;
    el.classList.add('visible');
    _piranhaToastTimer = setTimeout(function () { el.classList.remove('visible'); }, durationMs);
  }

  // -----------------------------
  // Bootstrapping
  // -----------------------------
  function tryInit() {
    const openModalBtn = document.getElementById('piranha-open-modal');
    const modal = document.getElementById('piranha-modal');

    if (openModalBtn && modal) {
      init();
    } else {
      const obs = new MutationObserver(function () {
        if (document.getElementById('piranha-open-modal') && document.getElementById('piranha-modal')) {
          obs.disconnect();
          init();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // -----------------------------
  // Global state
  // -----------------------------
  let currentStep = 0;
  const totalSteps = 6;

  let selectedData = {
    impressionMethod: null,
    deliveryDays: 14,
    deliverySpeed: 'standard',
    designChoice: null,
    selectedPredesign: null,
    selectedPredesignImage: null,
    baseColour: null,
    baseColourHex: '#FF0000',
    customDesign: false,
    complexDesign: false,
    complexDesignPrice: 0,
    storageCase: null,
    storageCaseImage: null,
    expressDelivery: false,
    insideNameTag: false,
    nameText: '',
    nameFont: 'arial',
    nameSize: 'medium',
    nameColor: '#FFFFFF',
    backupGumshields: false,
    backupQuantity: 0,
    designLayers: []
  };

  // Check if this is a hard refresh and clear state if so
  (function() {
    try {
      const perfData = performance.getEntriesByType("navigation")[0];
      if (perfData && perfData.type === "reload") {
        // Hard refresh detected
        sessionStorage.removeItem('piranhaGumshieldState');
        sessionStorage.removeItem('piranhaCurrentStep');
      }
    } catch (e) {
      console.warn('Could not check navigation type:', e);
    }
  })();

  // State persistence functions
  let _piranhaQuotaWarned = false;
  function saveStateToSession() {
    try {
      sessionStorage.setItem('piranhaGumshieldState', JSON.stringify(selectedData));
      sessionStorage.setItem('piranhaCurrentStep', currentStep.toString());
      return;
    } catch (e) {
      const isQuota = e && (e.name === 'QuotaExceededError' || e.code === 22 || e.code === 1014);
      if (isQuota) {
        // Retry without heavy base64 image dataURLs. Layer metadata persists
        // so the design structure restores; images will need to be re-added
        // on a fresh page. Previously this error was swallowed silently and
        // the entire state stopped persisting.
        try {
          const lite = {
            ...selectedData,
            designLayers: (selectedData.designLayers || []).map(l =>
              l.type === 'image' ? { ...l, dataURL: '' } : l
            )
          };
          sessionStorage.setItem('piranhaGumshieldState', JSON.stringify(lite));
          sessionStorage.setItem('piranhaCurrentStep', currentStep.toString());
          if (!_piranhaQuotaWarned) {
            _piranhaQuotaWarned = true;
            console.warn('Piranha: session storage full. Uploaded images will not survive a page refresh.');
          }
          return;
        } catch (_) { /* fall through */ }
      }
      console.warn('Could not save state to session storage:', e);
    }
  }

  function loadStateFromSession() {
    try {
      const savedState = sessionStorage.getItem('piranhaGumshieldState');
      const savedStep = sessionStorage.getItem('piranhaCurrentStep');
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        selectedData = { ...selectedData, ...parsedState };
        if (savedStep) {
          currentStep = parseInt(savedStep, 10);
        }
        return true;
      }
    } catch (e) {
      console.warn('Could not load state from session storage:', e);
    }
    return false;
  }

  // Load saved state on initialization
  const hasRestoredState = loadStateFromSession();

  // Function to restore UI elements from saved state
  function restoreUIFromState() {
    // Restore impression method selection
    if (selectedData.impressionMethod) {
      const impressionInput = document.querySelector(`input[name="impression-method"][value="${selectedData.impressionMethod}"]`);
      if (impressionInput) {
        impressionInput.checked = true;
        updateCardOpacity('impression-method');
        var scanPanel = document.getElementById('piranha-scan-upload-panel');
        if (scanPanel) scanPanel.style.display = selectedData.impressionMethod === 'dental-scan' ? 'block' : 'none';
      }
    }
    
    // Restore design choice
    if (selectedData.designChoice) {
      const designInput = document.querySelector(`input[name="design-choice"][value="${selectedData.designChoice}"]`);
      if (designInput) {
        designInput.checked = true;
        updateCardOpacity('design-choice');
        const gallery = document.getElementById('piranha-predesign-gallery');
        if (gallery) gallery.style.display = selectedData.designChoice === 'predesign' ? 'block' : 'none';
      }
    }
    
    // Restore predesign selection if applicable
    if (selectedData.selectedPredesign) {
      const predesignInput = document.querySelector(`input[name="predesign-selection"][value="${selectedData.selectedPredesign}"]`);
      if (predesignInput) {
        predesignInput.checked = true;
        updateCardOpacity('predesign-selection');
      }
    }
    
   // Restore base colour selection
if (selectedData.baseColour) {
  const colourInput = document.querySelector(`input[name="base-colour"][value="${selectedData.baseColour}"]`);
  if (colourInput) {
    colourInput.checked = true;
    updateCardOpacity('base-colour');
    
    // IMPORTANT: Actually apply the color to the canvas
    if (selectedData.baseColourHex) {
      updateGumshieldColour(selectedData.baseColourHex);
    }
  }
}
    
    // Restore storage case selection
    if (selectedData.storageCase) {
      const storageCaseInput = document.querySelector(`input[name="storage-case"][value="${selectedData.storageCase}"]`);
      if (storageCaseInput) {
        storageCaseInput.checked = true;
        updateCardOpacity('storage-case');
      }
    }
    
    // Restore express production
    const expressInput = document.getElementById('piranha-express-addon-check');
    if (expressInput) {
      expressInput.checked = selectedData.expressDelivery;
    }
    
    // Restore inside name tag
    const nameTagInput = document.getElementById('piranha-nametag-addon-check');
    if (nameTagInput) {
      nameTagInput.checked = selectedData.insideNameTag;
      const nameSection = document.getElementById('piranha-name-internal-section');
      if (nameSection) {
        if (selectedData.insideNameTag) {
          nameSection.classList.add('active');
        } else {
          nameSection.classList.remove('active');
        }
      }
    }
    
    // Restore name text
    if (selectedData.insideNameTag && selectedData.nameText) {
      const nameInput = document.getElementById('piranha-name-input');
      if (nameInput) {
        nameInput.value = selectedData.nameText;
      }
    }
    
    // Restore backup gumshields
    const backupInput = document.getElementById('piranha-backup-addon-check');
    if (backupInput) {
      backupInput.checked = selectedData.backupGumshields;
      const backupSection = document.getElementById('piranha-backup-internal-section');
      if (backupSection) {
        if (selectedData.backupGumshields) {
          backupSection.classList.add('active');
        } else {
          backupSection.classList.remove('active');
        }
      }
    }
    
    // Restore backup quantity
    if (selectedData.backupGumshields && selectedData.backupQuantity > 0) {
      const quantityInput = document.getElementById('piranha-backup-qty-input');
      if (quantityInput) {
        quantityInput.value = selectedData.backupQuantity;
      }
    }
    
    // Restore design layers if any
    if (selectedData.designLayers && selectedData.designLayers.length > 0) {
      rerenderAllLayers();
  
      renderFinalPreview();
    }
    
    // Update summary
    updateSummary();
  }

  // Function to update card opacity based on selection
  function updateCardOpacity(inputName) {
    const allInputs = document.querySelectorAll(`input[name="${inputName}"]`);
    allInputs.forEach(input => {
      const card = input.closest('.piranha-option-card, .piranha-colour-option, .piranha-predesign-option, .piranha-storage-case');
      if (card) {
        if (input.checked) {
          card.style.opacity = '1';
        } else {
          card.style.opacity = '0.6';
        }
      }
    });
  }

  // --- History (Undo/Redo) ---
  const history = [];
  const future = [];
  function deepClone(obj){ return typeof structuredClone === 'function' ? structuredClone(obj) : JSON.parse(JSON.stringify(obj)); }
  function snapshotState() {
    return {
      designLayers: deepClone(selectedData.designLayers),
      selectedLayerId: selectedLayerId
    };
  }
  function pushHistory() {
    history.push(snapshotState());
    future.length = 0;
    saveStateToSession();
  }
  function applyState(state) {
    selectedData.designLayers = deepClone(state.designLayers || []);
    selectedLayerId = state.selectedLayerId ?? null;
    rerenderAllLayers();
    if (selectedLayerId) selectLayer(selectedLayerId); else deselectLayer();
    renderFinalPreview();
  }
  function undo() {
    if (history.length === 0) return;
    const current = snapshotState();
    future.push(current);
    const prev = history.pop();
    applyState(prev);
  }
  function redo() {
    if (future.length === 0) return;
    const current = snapshotState();
    history.push(current);
    const next = future.pop();
    applyState(next);
  }

  // Updated pricing object with actual variant prices
  const variantPrices = {
    'impression-kit': 79.00,
    'dental-scan': 79.00,
    'own-models': 79.00,
    'express': 29.00,
    'nametag': 10.00
  };

  const pricing = {
  base: 79.00,
  customDesign: 0,
  complexDesign: 0,
  expressDelivery: 0, // Changed from variantPrices['express'] to 0
  nameTag: variantPrices['nametag'],
  backupPrice: 39.50
};

  // Variant ID Mapping
  const VARIANT_IDS = {
    gumshield: {
      'impression-kit': '52261441995088',
      'dental-scan': '52261442027856',
      'own-models': '52261442060624',
      'gym-kit': '52276665712976'

    },
    addons: {
      customisation: '52261391499600',
      express: '52261381472592',
      nameTag: '52261383536976'
    }
  };


// Discount code for gym kit
const GYM_KIT_DISCOUNT_CODE = 'GYM5';  // 5% discount code
const GYM_KIT_DISCOUNT_RATE = 0.95;    // 95% of original price (5% off)

  // Delivery Time Calculation Functions
  function getUKTime() {
    let now = new Date();
    let utcOffset = now.getTimezoneOffset() / 60;
    let ukOffset = 0;
    let startBST = new Date(now.getFullYear(), 2, 31);
    startBST.setDate(startBST.getDate() - startBST.getDay());
    let endBST = new Date(now.getFullYear(), 9, 31);
    endBST.setDate(endBST.getDate() - endBST.getDay());
    if (now >= startBST && now < endBST) ukOffset = 1;
    return new Date(now.getTime() + (ukOffset + utcOffset) * 3600000);
  }

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  function formatFutureDate(date) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${days[date.getDay()]}, ${date.getDate()}${getOrdinalSuffix(date.getDate())} ${months[date.getMonth()]}`;
  }

  function calculateDeliveryDate() {
    var now = getUKTime();
    var cutoff = new Date(now);
    cutoff.setHours(15, 15, 0, 0);
    var d = new Date(now);
    if (now >= cutoff) d.setDate(d.getDate() + 1);
    var day = d.getDay();
    if (day === 0) d.setDate(d.getDate() + 1);
    else if (day === 6) d.setDate(d.getDate() + 2);
    d.setDate(d.getDate() + 1);
    day = d.getDay();
    if (day === 0) d.setDate(d.getDate() + 1);
    else if (day === 6) d.setDate(d.getDate() + 2);
    return d;
  }

  function getFormattedDeliveryDate() {
    return formatFutureDate(calculateDeliveryDate());
  }

  let layerIdCounter = 0;
  let selectedLayerId = null;

  // Customiser refs (bound in init)
  let svgEl, canvasContainerEl, selectionEl, selectionBoxEl;
  let topToolbarEl, flyResizeEl, flyRotateEl;
  let resizeSliderEl, resizeValueEl, rotateSliderEl, rotateValueEl;

// ─────────────────────────────────────────────────────────────────────────────
// Prebuilt design library — read live from Meridian (the source of truth).
//
// The cards used to be a hardcoded list in the pre-designs snippet. They now
// come from the Meridian read API, so adding or editing a design in Meridian
// updates the storefront with no theme change. Selection logic is unchanged:
// each card is still an input[name="predesign-selection"] carrying the design
// name (the order-match key) as its value and the preview URL as data-image.
// ─────────────────────────────────────────────────────────────────────────────

// Static library file served straight from the CDN (fast, no function cold
// start) — the normal path. The function URL is the fallback.
var PIRANHA_PREDESIGNS_STATIC = 'https://npuvhxakffxqoszytkxw.supabase.co/storage/v1/object/public/predesign-previews/library.json';
var PIRANHA_PREDESIGNS_URL = 'https://npuvhxakffxqoszytkxw.supabase.co/functions/v1/piranha-predesigns';

function piranhaEscapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function bindPredesignRadio(radio) {
  radio.addEventListener('change', function () {
    selectedData.selectedPredesign = this.value;
    selectedData.selectedPredesignImage = this.dataset.image;
    selectedData.baseColour = null;
    selectedData.baseColourHex = null;
    selectedData.customDesign = false;

    if (typeof canvasState !== 'undefined' && canvasState.elements) {
      canvasState.elements = [];
    }
    selectedData.customizationData = [];

    if (typeof renderCanvas === 'function') {
      renderCanvas();
    }

    updateCardOpacity('predesign-selection');
    saveStateToSession();
    updateSummary();
    updateNavigationButtons();
  });
}

async function loadPredesignsFromMeridian() {
  var grid = document.querySelector('.piranha-predesign-grid');
  if (!grid) return;
  try {
    var data = null;
    // Fast path: the static library file, served from the CDN.
    try {
      var rs = await fetch(PIRANHA_PREDESIGNS_STATIC);
      if (rs.ok) data = await rs.json();
    } catch (_) { /* fall through to the API */ }
    // Fallback: the read API (e.g. before the file has first been built).
    if (!data || !data.designs) {
      var res = await fetch(PIRANHA_PREDESIGNS_URL, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      data = await res.json();
    }
    var designs = (data && data.designs) || [];
    if (!designs.length) {
      grid.innerHTML = '<p style="grid-column:1/-1;margin:0;padding:12px;color:#888;font-size:14px;">No designs available right now.</p>';
      return;
    }
    grid.innerHTML = designs.map(function (d) {
      var name = piranhaEscapeHtml(d.name);
      var img = piranhaEscapeHtml(d.previewUrl);
      var label = piranhaEscapeHtml(d.title || d.name);
      return '<label class="piranha-predesign-option">' +
        '<input type="radio" name="predesign-selection" value="' + name + '" data-image="' + img + '">' +
        '<div class="piranha-predesign-card">' +
        '<img src="' + img + '" alt="' + label + ' Design" loading="lazy">' +
        '<span class="piranha-predesign-name">' + label + '</span>' +
        '</div></label>';
    }).join('');
    grid.querySelectorAll('input[name="predesign-selection"]').forEach(bindPredesignRadio);
    // Re-apply a saved selection now that the cards exist (e.g. page restore).
    if (selectedData && selectedData.selectedPredesign) {
      grid.querySelectorAll('input[name="predesign-selection"]').forEach(function (r) {
        if (r.value === selectedData.selectedPredesign) r.checked = true;
      });
      if (typeof updateCardOpacity === 'function') updateCardOpacity('predesign-selection');
    }
  } catch (e) {
    console.error('[piranha] could not load predesigns from Meridian', e);
    grid.innerHTML = '<p style="grid-column:1/-1;margin:0;padding:12px;color:#b91c1c;font-size:14px;">Could not load designs. Please refresh the page.</p>';
  }
}

function init() {
    setupEventListeners();
    setupOptions();
    loadPredesignsFromMeridian();

    window.selectedData = selectedData;

    // Customiser refs
    svgEl = document.getElementById('piranha-design-canvas');
    canvasContainerEl = document.getElementById('piranha-canvas-container');
    selectionEl = document.getElementById('piranha-selection-controls');
    selectionBoxEl = selectionEl?.querySelector('.piranha-selection-box');
    topToolbarEl = document.getElementById('piranha-top-toolbar');
    flyResizeEl = document.getElementById('piranha-flyout-resize');
    flyRotateEl = document.getElementById('piranha-flyout-rotate');
    resizeSliderEl = document.getElementById('piranha-resize-slider');
    resizeValueEl = document.getElementById('piranha-resize-value');
    rotateSliderEl = document.getElementById('piranha-rotate-slider');
    rotateValueEl = document.getElementById('piranha-rotate-value');

    setupCustomizerListeners();
    setupTextModal();
    setupColourPickerModal();

    updateProgress();
    updateDeliveryDateDisplay();
    pushHistory();
    updatePricesInUI();
    
    
    updateSummary();
  }

// Click outside modal backdrop to close. closeModal() itself bails when
// an upload is in flight, so the backdrop click is implicitly guarded.
(function () {
  var modal = document.getElementById('piranha-modal');
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target.classList.contains('piranha-modal')) {
        closeModal();
      }
    });
  }
})();

  function updatePricesInUI() {
    const expressPriceEl = document.getElementById('express-price');
    if (expressPriceEl) {
      expressPriceEl.textContent = variantPrices['express'].toFixed(2);
    }

    const nametagPriceEl = document.getElementById('nametag-price');
    if (nametagPriceEl) {
      nametagPriceEl.textContent = variantPrices['nametag'].toFixed(2);
    }

    const backupPriceEl = document.getElementById('backup-price');
    if (backupPriceEl) {
      backupPriceEl.textContent = pricing.backupPrice.toFixed(2);
    }
  }

  function setupEventListeners() {
    const openModalBtn = document.getElementById('piranha-open-modal');
    if (openModalBtn) {
      openModalBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = document.getElementById('piranha-modal');
        if (modal) {
          modal.classList.add('active');
          document.body.classList.add('piranha-modal-open');
          
          // Restore state if exists
          if (hasRestoredState || loadStateFromSession()) {
            restoreUIFromState();
          }
          
          updateStep();
        }
      });
    }

    const closeBtn = document.getElementById('piranha-close-main');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    const nextBtn = document.getElementById('piranha-next-btn');
    const backBtn = document.getElementById('piranha-back-btn');
    if (nextBtn) nextBtn.addEventListener('click', nextStep);
    if (backBtn) backBtn.addEventListener('click', prevStep);

    setupTouchFriendlySelections();
  }


function preloadFonts() {
  const fonts = [
    'Arial', 'Impact', 'Times New Roman', 'Courier', 'Georgia', 'Verdana',
    'SuperMario256', 'Pokemon Hollow', 'Pokemon Solid', 'Ransom', 'Boldstrom',
    'Blood Hunter', 'Death Bones', 'Impacted', 'Apple Peach', 'Wonderbar Demo',
    'Made by Tommy', 'Parry Hotter', 'Luckiest Guy', 'Honey Bear', 'Milker',
    'Wednesday', 'Attack Of Monster', 'Frank', 'Crackman', 'Green Energy',
    'Moldie', 'Galantic', 'Spooky Ghost', 'Game of Thrones', 'The Godfather',
    'Analogy', 'Moliga', 'Candy Hunter'
  ];

  // Create hidden div to force font loading
  const preloadDiv = document.createElement('div');
  preloadDiv.style.position = 'absolute';
  preloadDiv.style.left = '-9999px';
  preloadDiv.style.visibility = 'hidden';
  
  fonts.forEach(font => {
    const span = document.createElement('span');
    span.style.fontFamily = font;
    span.textContent = 'Loading';
    preloadDiv.appendChild(span);
  });
  
  document.body.appendChild(preloadDiv);
  
  (document.fonts && document.fonts.ready || Promise.resolve()).then(function () {
    document.body.removeChild(preloadDiv);
  });
}

  function setupTouchFriendlySelections() {
    const selectionElements = document.querySelectorAll([
      '.piranha-colour-option',
      '.piranha-predesign-option', 
      '.piranha-option-card',
      '.piranha-step label'
    ].join(', '));
    
    const radioLabels = Array.from(selectionElements).filter(element => {
      return element.querySelector('input[type="radio"]') !== null;
    });
    
    radioLabels.forEach(element => {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;
      let isTouchMoving = false;
      
      element.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        isTouchMoving = false;
      }, { passive: true });
      
      element.addEventListener('touchmove', function(e) {
        const touchX = e.touches[0].clientX;
        const touchY = e.touches[0].clientY;
        const deltaX = Math.abs(touchX - touchStartX);
        const deltaY = Math.abs(touchY - touchStartY);
        
        if (deltaX > 10 || deltaY > 10) {
          isTouchMoving = true;
        }
      }, { passive: true });
      
      element.addEventListener('touchend', function(e) {
        const touchDuration = Date.now() - touchStartTime;
        
        if (!isTouchMoving && touchDuration < 500) {
          const input = this.querySelector('input[type="radio"]');
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        
        e.preventDefault();
      });
    });
  }

  function renderScanFileList() {
    const list = document.getElementById('piranha-scan-file-list');
    if (!list) return;
    list.innerHTML = '';
    (window.piranhaScanFiles || []).forEach((f, idx) => {
      const li = document.createElement('li');
      li.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:10px 12px;background:#fff;border:1px solid #e3e8ee;border-radius:6px;margin-bottom:6px;font-size:13px;';
      const left = document.createElement('span');
      left.innerHTML = `<strong>${f.name}</strong> &middot; ${(f.size / 1024 / 1024).toFixed(2)} MB`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = '×';
      btn.setAttribute('aria-label', 'Remove ' + f.name);
      btn.style.cssText = 'background:none;border:none;color:#c62828;cursor:pointer;font-size:20px;line-height:1;padding:0 6px;';
      btn.addEventListener('click', function () {
        window.piranhaScanFiles.splice(idx, 1);
        selectedData.scanFiles = window.piranhaScanFiles.map(file => ({
          name: file.name, size: file.size, type: file.type
        }));
        renderScanFileList();
        saveStateToSession();
        updateNavigationButtons();
      });
      li.appendChild(left);
      li.appendChild(btn);
      list.appendChild(li);
    });
  }

  function setupOptions() {
    // Step 0
    document.querySelectorAll('input[name="impression-method"]').forEach(i => {
      i.addEventListener('change', function () {
        selectedData.impressionMethod = this.value;
        selectedData.deliveryDays = parseInt(this.dataset.delivery);
        updateCardOpacity('impression-method');

        const scanPanel = document.getElementById('piranha-scan-upload-panel');
        if (scanPanel) {
          scanPanel.style.display = this.value === 'dental-scan' ? 'block' : 'none';
        }

        // Clear any previously uploaded scan files when the customer
        // switches to a non-scan impression method, otherwise stale files
        // would still ship in the order ZIP.
        if (this.value !== 'dental-scan') {
          window.piranhaScanFiles = [];
          selectedData.scanFiles = [];
          const errEl = document.getElementById('piranha-scan-error');
          if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
          renderScanFileList();
        }

        saveStateToSession();
        updateSummary();
        updateNavigationButtons();
      });
    });

    // Step 0: dental scan file upload
    window.piranhaScanFiles = window.piranhaScanFiles || [];
    const scanFileInput = document.getElementById('piranha-scan-file-input');
    if (scanFileInput) {
      scanFileInput.addEventListener('change', function (e) {
        const files = Array.from(e.target.files || []);
        const MAX_BYTES = 50 * 1024 * 1024;
        const VALID_EXT = /\.(stl|ply|obj)$/i;
        const errors = [];
        files.forEach(f => {
          if (!VALID_EXT.test(f.name)) {
            errors.push(`${f.name}: not an STL, PLY, or OBJ file`);
            return;
          }
          if (f.size > MAX_BYTES) {
            errors.push(`${f.name}: too large (${(f.size / 1024 / 1024).toFixed(1)} MB, max 50 MB)`);
            return;
          }
          window.piranhaScanFiles.push(f);
        });

        selectedData.scanFiles = window.piranhaScanFiles.map(f => ({
          name: f.name, size: f.size, type: f.type
        }));

        const errEl = document.getElementById('piranha-scan-error');
        if (errEl) {
          errEl.style.display = errors.length ? 'block' : 'none';
          errEl.textContent = errors.join('\n');
        }

        renderScanFileList();
        saveStateToSession();
        updateNavigationButtons();
        this.value = '';
      });
    }

    // Step 1: Design Choice
    document.querySelectorAll('input[name="design-choice"]').forEach(i => {
      i.addEventListener('change', function () {
        selectedData.designChoice = this.value;
        
        const predesignGallery = document.getElementById('piranha-predesign-gallery');
        if (this.value === 'predesign') {
          if (predesignGallery) predesignGallery.style.display = 'block';
          selectedData.baseColour = null;
          selectedData.baseColourHex = null;
          selectedData.customDesign = false;
          
          if (typeof canvasState !== 'undefined' && canvasState.elements) {
            canvasState.elements = [];
          }
          selectedData.customizationData = [];
          
          if (typeof renderCanvas === 'function') {
            renderCanvas();
          }
        } else {
          if (predesignGallery) predesignGallery.style.display = 'none';
          selectedData.selectedPredesign = null;
          selectedData.selectedPredesignImage = null;
          selectedData.customDesign = true;
          
          const previewWrapper = document.querySelector('.piranha-complex-preview-wrapper');
          if (previewWrapper) {
            previewWrapper.remove();
          }
          
          document.querySelectorAll('input[name="predesign-selection"]').forEach(radio => {
            radio.checked = false;
          });
        }
        updateCardOpacity('design-choice');
        saveStateToSession();
        updateSummary();
        updateNavigationButtons();
      });
    });

    // Pre-design selection. The cards are rendered dynamically from Meridian
    // (loadPredesignsFromMeridian), so the change handler lives in the shared
    // bindPredesignRadio and is also re-applied after that render. Any static
    // cards present at init get bound here too.
    document.querySelectorAll('input[name="predesign-selection"]').forEach(bindPredesignRadio);

    // Step 2: Color Selection
    document.querySelectorAll('input[name="base-colour"]').forEach(i => {
      i.addEventListener('change', function () {
        selectedData.baseColour = this.value;
        
        const colorType = this.dataset.type;
        
        if (colorType === 'complex') {
          selectedData.complexDesign = true;
          selectedData.complexDesignPrice = parseInt(this.dataset.price) || 10;
          selectedData.baseColourHex = '#FFFFFF';
          selectedData.complexDesignImageUrl = this.dataset.img;
        } else {
          selectedData.complexDesign = false;
          selectedData.complexDesignPrice = 0;
          selectedData.baseColourHex = this.dataset.colour;
          selectedData.complexDesignImageUrl = null;
        }
        
        updateGumshieldColour(selectedData.baseColourHex);
        updateCardOpacity('base-colour');
        saveStateToSession();
        updateSummary();
        updateNavigationButtons();
      });
    });

    // Step 3: Storage Case Selection
    document.querySelectorAll('input[name="storage-case"]').forEach(i => {
      i.addEventListener('change', function () {
        selectedData.storageCase = this.value;
        selectedData.storageCaseImage = this.dataset.image;
        updateCardOpacity('storage-case');
        saveStateToSession();
        updateSummary();
        updateNavigationButtons();
      });
    });

    // Step 4: Express Production Addon - Always enabled by default
const expressAddonCheck = document.getElementById('piranha-express-addon-check');
if (expressAddonCheck) {
  // Set express delivery as always true
  selectedData.expressDelivery = true;
  selectedData.deliverySpeed = 'express';
  
  // Disable the change event since it's locked
  expressAddonCheck.addEventListener('change', function () {
    // Keep it always checked
    this.checked = true;
    selectedData.expressDelivery = true;
    selectedData.deliverySpeed = 'express';
    saveStateToSession();
    updateSummary();
  });
}

    // Step 4: Inside Name Tag Addon
    const nameAddonCheck = document.getElementById('piranha-nametag-addon-check');
    if (nameAddonCheck) {
      nameAddonCheck.addEventListener('change', function () {
        selectedData.insideNameTag = this.checked;
        const nameInternalSection = document.getElementById('piranha-name-internal-section');
        if (nameInternalSection) {
          if (selectedData.insideNameTag) {
            nameInternalSection.classList.add('active');
          } else {
            nameInternalSection.classList.remove('active');
            selectedData.nameText = '';
            const nameInput = document.getElementById('piranha-name-input');
            if (nameInput) {
              nameInput.value = '';
            }
          }
        }
        saveStateToSession();
        updateSummary();
      });
    }

    const nameInput = document.getElementById('piranha-name-input');
    if (nameInput) nameInput.addEventListener('input', function () {
      selectedData.nameText = this.value;
      saveStateToSession();
      updateInsideNamePreview();
    });

    const nameFont = document.getElementById('piranha-name-font');
    if (nameFont) nameFont.addEventListener('change', function () {
      selectedData.nameFont = this.value;
      saveStateToSession();
      updateInsideNamePreview();
    });

    const nameWeight = document.getElementById('piranha-name-weight');
    if (nameWeight) nameWeight.addEventListener('change', function () {
      selectedData.nameWeight = this.value;
      saveStateToSession();
      updateInsideNamePreview();
    });

    const nameSize = document.getElementById('piranha-name-size');
    if (nameSize) nameSize.addEventListener('change', function () {
      selectedData.nameSize = this.value;
      saveStateToSession();
      updateInsideNamePreview();
    });

    const nameColor = document.getElementById('piranha-name-color');
    if (nameColor) nameColor.addEventListener('change', function () {
      selectedData.nameColor = this.value;
      saveStateToSession();
      updateInsideNamePreview();
    });

    // Step 4: Backup Gumshields Checkbox
    const backupAddonCheck = document.getElementById('piranha-backup-addon-check');
    const backupInternalSection = document.getElementById('piranha-backup-internal-section');
    if (backupAddonCheck && backupInternalSection) {
      backupAddonCheck.addEventListener('change', function() {
        if (this.checked) {
          backupInternalSection.classList.add('active');
          selectedData.backupGumshields = true;
          selectedData.backupQuantity = parseInt(document.getElementById('piranha-backup-qty-input').value) || 1;
        } else {
          backupInternalSection.classList.remove('active');
          selectedData.backupGumshields = false;
          selectedData.backupQuantity = 0;
        }
        saveStateToSession();
        updateSummary();
      });
    }

    // Step 4: Backup Gumshields Quantity Selector
    const qtyMinus = document.getElementById('piranha-backup-qty-minus');
    const qtyPlus = document.getElementById('piranha-backup-qty-plus');
    const qtyInput = document.getElementById('piranha-backup-qty-input');
    
    if (qtyMinus) {
      qtyMinus.addEventListener('click', () => {
        if (qtyInput && qtyInput.value > 1) {
          qtyInput.value = parseInt(qtyInput.value) - 1;
          selectedData.backupQuantity = parseInt(qtyInput.value);
          const backupPriceEl = document.getElementById('backup-price');
          if (backupPriceEl) {
            backupPriceEl.textContent = (pricing.backupPrice * selectedData.backupQuantity).toFixed(2);
          }
          saveStateToSession();
          updateSummary();
        }
      });
    }
    
    if (qtyPlus) {
      qtyPlus.addEventListener('click', () => {
        if (qtyInput && qtyInput.value < 4) {
          qtyInput.value = parseInt(qtyInput.value) + 1;
          selectedData.backupQuantity = parseInt(qtyInput.value);
          const backupPriceEl = document.getElementById('backup-price');
          if (backupPriceEl) {
            backupPriceEl.textContent = (pricing.backupPrice * selectedData.backupQuantity).toFixed(2);
          }
          saveStateToSession();
          updateSummary();
        }
      });
    }
  }

  function svgPointFromEvent(evt) {
    const pt = svgEl.createSVGPoint();
    pt.x = evt.clientX;
    pt.y = evt.clientY;
    return pt.matrixTransform(svgEl.getScreenCTM().inverse());
  }

  function preciseCornersForGroup(g) {
    const bb = g.getBBox();
    const m = g.getScreenCTM();
    const containerRect = canvasContainerEl.getBoundingClientRect();

    function corner(x, y) {
      const p = svgEl.createSVGPoint();
      p.x = x; p.y = y;
      const q = p.matrixTransform(m);
      return { x: q.x - containerRect.left, y: q.y - containerRect.top };
    }

    const p1 = corner(bb.x, bb.y);
    const p2 = corner(bb.x + bb.width, bb.y);
    const p3 = corner(bb.x + bb.width, bb.y + bb.height);
    const p4 = corner(bb.x, bb.y + bb.height);

    const xs = [p1.x, p2.x, p3.x, p4.x];
    const ys = [p1.y, p2.y, p3.y, p4.y];
    const rect = {
      left: Math.min(...xs),
      top: Math.min(...ys),
      width: Math.max(...xs) - Math.min(...xs),
      height: Math.max(...ys) - Math.min(...ys)
    };

    return { rect, corners: [p1, p2, p3, p4] };
  }

  function mapCornersToCardinal(points) {
    const pts = points.map(p => ({ ...p }));
    const NW = pts.reduce((a, b) =>
      (b.y < a.y - 0.5 || (Math.abs(b.y - a.y) <= 0.5 && b.x < a.x)) ? b : a
    );
    const SE = pts.reduce((a, b) =>
      (b.y > a.y + 0.5 || (Math.abs(b.y - a.y) <= 0.5 && b.x > a.x)) ? b : a
    );
    const rest = pts.filter(p => p !== NW && p !== SE);
    const A = rest[0], B = rest[1];
    const NE = (A.y < B.y) ? A : B;
    const SW = (A.y < B.y) ? B : A;
    return { NW, NE, SE, SW };
  }

  function currentLayer() {
    return selectedLayerId
      ? selectedData.designLayers.find(l => l.id === selectedLayerId) || null
      : null;
  }

  function currentLayerGroup() {
    return selectedLayerId
      ? svgEl.querySelector(`[data-layer-id="${selectedLayerId}"]`)
      : null;
  }

  function renderLayer(layerData) {
  const canvasLayers = document.getElementById('piranha-canvas-layers');
  if (!canvasLayers) {
    console.error('Canvas layers element not found');
    return;
  }

  let g = canvasLayers.querySelector(`[data-layer-id="${layerData.id}"]`);
  if (!g) {
    g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.setAttribute('data-layer-id', layerData.id);
    g.style.cursor = 'move';
    canvasLayers.appendChild(g);
  } else {
    g.innerHTML = '';
  }

    if (layerData.type === 'image') {
      const image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', layerData.dataURL);
      image.setAttribute('width', layerData.w);
      image.setAttribute('height', layerData.h);
      image.setAttribute('x', -layerData.w / 2);
      image.setAttribute('y', -layerData.h / 2);
      image.setAttribute('preserveAspectRatio', 'none');
      g.appendChild(image);
    } else {
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.setAttribute('font-family', layerData.font);
      text.setAttribute('font-size', layerData.size);
      text.setAttribute('fill', layerData.color);
      text.setAttribute('font-weight', layerData.weight);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.textContent = layerData.text;
      g.appendChild(text);
    }

    updateLayerTransform(layerData, g);
    updateSelectionBox(layerData);
  }

 function rerenderAllLayers() {
  const canvasLayers = document.getElementById('piranha-canvas-layers');
  if (!canvasLayers) {
    console.error('Canvas layers not found for rerender');
    return;
  }
  canvasLayers.innerHTML = '';
  selectedData.designLayers.forEach((ld, index) => {
    renderLayer(ld);
  });
}




  function updateLayerTransform(layerData, g) {
    if (!g) g = currentLayerGroup();
    if (!g) return;

    const flipX = layerData.flipX || 1;
    const flipY = layerData.flipY || 1;
    g.setAttribute(
      'transform',
      `translate(${layerData.tx}, ${layerData.ty}) rotate(${layerData.rot}) scale(${layerData.scale * flipX}, ${layerData.scale * flipY})`
    );
  }

function updateSelectionBox(layerData) {
  if (!selectionEl) return;

  const g = currentLayerGroup();
  if (!g || !selectedLayerId) {
    selectionEl.style.display = 'none';
    return;
  }

  // Force a reflow to ensure transform is applied before getting bounding rect
  void g.offsetHeight;

  try {
    // Use the actual rendered bounding box in screen coordinates
    const elemRect = g.getBoundingClientRect();
    const containerRect = canvasContainerEl.getBoundingClientRect();
    
    // Calculate position relative to container
    const left = elemRect.left - containerRect.left;
    const top = elemRect.top - containerRect.top;
    const width = elemRect.width;
    const height = elemRect.height;

    // Use requestAnimationFrame to ensure smooth updates
    requestAnimationFrame(() => {
      selectionEl.style.display = 'block';
      selectionEl.style.left = left + 'px';
      selectionEl.style.top = top + 'px';
      selectionEl.style.width = width + 'px';
      selectionEl.style.height = height + 'px';
      
      // Keep selection box axis-aligned (no rotation)
      selectionEl.style.transform = 'none';
      selectionEl.style.transformOrigin = 'center center';
      
      const rotateHandle = selectionEl.querySelector('.piranha-rotate-handle');
      const moveHandle = selectionEl.querySelector('.piranha-move-handle');
      const resizeIconHandle = selectionEl.querySelector('.piranha-resize-icon-handle');

      if (rotateHandle) {
        rotateHandle.style.display = 'flex';
        rotateHandle.style.left = (width / 2) + 'px';
        rotateHandle.style.bottom = '-34px';
        rotateHandle.style.transform = 'translateX(calc(-50% - 15px))';
      }

      if (moveHandle) {
        moveHandle.style.display = 'flex';
        moveHandle.style.left = (width / 2) + 'px';
        moveHandle.style.bottom = '-34px';
        moveHandle.style.transform = 'translateX(calc(-50% + 15px))';
      }
      
      if (resizeIconHandle) {
        resizeIconHandle.style.display = 'flex';
        resizeIconHandle.style.left = (width / 2) + 'px';
        resizeIconHandle.style.bottom = '-34px';
        resizeIconHandle.style.transform = 'translateX(calc(-50% - 31.5px))';
      }
    });
  } catch (error) {
    console.error('Error updating selection box:', error);
    selectionEl.style.display = 'none';
  }
}

 function selectLayer(layerId) {
  selectedLayerId = layerId;
  document.querySelectorAll('.piranha-layer-item').forEach(item => {
    item.classList.toggle('active', parseInt(item.dataset.layerId) === layerId);
  });

  const layerData = currentLayer();
  if (!layerData) return;

  updateSelectionBox(layerData);


  updateEditButtonVisibility();

  if (resizeSliderEl && resizeValueEl) {
    const scalePct = Math.round((layerData.scale || 1) * 100);
    resizeSliderEl.value = scalePct;
    resizeValueEl.value = scalePct;
  }
  if (rotateSliderEl && rotateValueEl) {
    rotateSliderEl.value = Math.round(layerData.rot || 0);
    rotateValueEl.value = Math.round(layerData.rot || 0);
  }
}

  function openTextEditorForLayer(layerId) {
  const layerData = selectedData.designLayers.find(l => l.id === layerId);
  if (!layerData || layerData.type !== 'text') return;
  
  const modal = document.getElementById('piranha-text-modal-overlay');
  const title = document.getElementById('piranha-text-modal-title');
  const confirmBtn = document.getElementById('piranha-text-modal-confirm');
  
  if (!modal) return;
  
  // Set to editing mode, not creating
  textCreateMode = false;
  textEditingLayerId = layerId;  // Store which layer we're editing
  
  modal.classList.add('active');
  
  if (title) title.textContent = 'Edit Text';
  if (confirmBtn) confirmBtn.textContent = 'Update Text';
  
  // Populate form with current values
  const textInput = document.getElementById('piranha-modal-text-input');
  const fontSelect = document.getElementById('piranha-modal-font-select');
  const fontWeightSelect = document.getElementById('piranha-modal-font-weight-select');
  const colorInput = document.getElementById('piranha-modal-text-color');
  
  if (textInput) textInput.value = layerData.text;
  if (fontSelect) fontSelect.value = layerData.font;
  if (fontWeightSelect) fontWeightSelect.value = layerData.weight || 'normal';
  if (colorInput) colorInput.value = layerData.color;

  // Highlight the tile matching this layer's colour and re-check legibility.
  syncTextColourUI();
  updateTextModalValidity();
}


function updateEditButtonVisibility() {
  // Check if there are ANY text layers in the design
  const hasTextLayers = selectedData.designLayers.some(l => l.type === 'text');
  
  // Check both top and bottom toolbar buttons
  const editBtnTop = document.getElementById('piranha-tool-edit-text');
  const editBtnBottom = document.getElementById('piranha-tool-edit-text-bottom');
  
  // Show ONLY if there are text layers
  if (editBtnTop) {
    editBtnTop.style.display = hasTextLayers ? 'flex' : 'none';
  }
  if (editBtnBottom) {
    editBtnBottom.style.display = hasTextLayers ? 'flex' : 'none';
  }
}

 function deselectLayer() {
  selectedLayerId = null;
  if (selectionEl) selectionEl.style.display = 'none';
  const addTextCheck = document.getElementById('piranha-add-text-check');
  const textEditor = document.getElementById('piranha-text-editor-section');
  if (addTextCheck && !textCreateMode) {
    addTextCheck.checked = false;
    textEditor?.classList.remove('active');
  }
  hideFlyouts();
  document.querySelectorAll('.piranha-layer-item').forEach(i => i.classList.remove('active'));
  

  updateEditButtonVisibility();
}


  function deleteLayer(layerId) {
  const index = selectedData.designLayers.findIndex(l => l.id === layerId);
  if (index > -1) {
    
    pushHistory();
    selectedData.designLayers.splice(index, 1);
    
    
    const g = svgEl.querySelector(`[data-layer-id="${layerId}"]`);
    if (g) g.remove();
    if (selectedLayerId === layerId) deselectLayer();

    renderFinalPreview();
    

    updateEditButtonVisibility();
  }
}

  // Resolves with the new layer id once the image has been compressed,
  // pushed to selectedData.designLayers, rendered, and selected.
  // Every in-flight call is registered in window.piranhaPendingImagePromises;
  // proceedToCheckout awaits Promise.all of those before generating the
  // screenshot, so checkout waits exactly as long as the work takes.
  window.piranhaPendingImagePromises = window.piranhaPendingImagePromises || [];

  // Bounding box of the whole mouthguard shape within the 2214x1278 canvas,
  // derived from the gumshield-clip path. Gallery designs full-bleed this so the
  // design reaches the uniform border on every side (incl. the tips).
  const FRONT_AREA = { w: 2175, h: 501, cx: 1110, cy: 591 };

  function addImageLayer(dataURL, options) {
    options = options || {};
    const promise = new Promise((resolve) => {
      const layerId = ++layerIdCounter;
      const img = new Image();
      img.onload = function () {
        try {
          const maxSize = 600;
          let w = img.width, h = img.height;
          if (w > maxSize || h > maxSize) {
            const r = Math.min(maxSize / w, maxSize / h);
            w *= r; h *= r;
          }

          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);

          const imageData = ctx.getImageData(0, 0, w, h);
          let hasTransparency = false;
          for (let i = 3; i < imageData.data.length; i += 4) {
            if (imageData.data[i] < 255) { hasTransparency = true; break; }
          }

          const compressedDataURL = hasTransparency
            ? canvas.toDataURL('image/png')
            : canvas.toDataURL('image/jpeg', 0.85);

          pushHistory();
          // Default: centred at ~2x. cover: scale to fill the entire printable
          // area edge-to-edge (gallery designs) so no base colour shows through.
          let tx = 1107, ty = 639, scale = 2;
          if (options.cover) {
            // 1.06 overshoot guarantees the design reaches the pointy tips even
            // with bbox rounding; the overflow is clipped to the front area and
            // hidden under the border frame.
            scale = Math.max(FRONT_AREA.w / w, FRONT_AREA.h / h) * 1.06;
            tx = FRONT_AREA.cx;
            ty = FRONT_AREA.cy;
          }
          const layerData = {
            id: layerId, type: 'image',
            dataURL: compressedDataURL,
            w, h,
            tx, ty,
            rot: 0, scale, flipX: 1, flipY: 1
          };
          selectedData.designLayers.push(layerData);
          rerenderAllLayers();
      
          renderFinalPreview();

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              selectLayer(layerId);
              resolve(layerId);
            });
          });
        } catch (err) {
          console.error('addImageLayer failed:', err);
          resolve(null);
        }
      };
      img.onerror = function () {
        console.error('addImageLayer: image failed to load');
        resolve(null);
      };
      img.src = dataURL;
    });

    window.piranhaPendingImagePromises.push(promise);
    promise.finally(() => {
      const idx = window.piranhaPendingImagePromises.indexOf(promise);
      if (idx >= 0) window.piranhaPendingImagePromises.splice(idx, 1);
    });

    return promise;
  }

  function duplicateLayer() {
  if (!selectedLayerId) {
    return;
  }
  const src = currentLayer();
  if (!src) {
    return;
  }
  
  pushHistory();
  const newId = ++layerIdCounter;
  
  // Deep clone the source layer
  const copy = deepClone(src);
  copy.id = newId;
  copy.tx = src.tx + 50;  // Offset more so it's visible
  copy.ty = src.ty + 50;
  
  
  selectedData.designLayers.push(copy);
  rerenderAllLayers();
  renderFinalPreview();
  

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      selectLayer(newId);
    });
  });
  
}

  function flipLayer(direction) {
    const lp = currentLayer();
    if (!lp) return;
    pushHistory();
    if (direction === 'horizontal') lp.flipX = (lp.flipX || 1) * -1;
    else lp.flipY = (lp.flipY || 1) * -1;
    updateLayerTransform(lp);
    updateSelectionBox(lp);
    renderFinalPreview();
  }

  function deleteSelectedLayer() {
    if (selectedLayerId) deleteLayer(selectedLayerId);
  }

  let dragging = false;
  let dragPointerId = null;
  let startPtrSvg = null;
  let startTx = 0, startTy = 0;
  let rafId = null;
  let pendingMove = null;
  let dragThresholdMet = false;
  const DRAG_THRESHOLD = 3;

  function handleCanvasPointerDown(e) {
  const target = e.target.closest('[data-layer-id]');
  if (!target) {
    // Clicked on empty canvas space - deselect
    deselectLayer();
    hideFlyouts();
    return;
  }
    const layerId = parseInt(target.getAttribute('data-layer-id'), 10);
    selectLayer(layerId);

    dragPointerId = e.pointerId;
    target.setPointerCapture?.(dragPointerId);

    const lp = currentLayer();
    if (!lp) return;

    dragging = true;
    dragThresholdMet = false;
    startPtrSvg = svgPointFromEvent(e);
    startTx = lp.tx;
    startTy = lp.ty;

    document.body.style.cursor = 'grabbing';
    
    e.preventDefault();
  }

  function handleCanvasPointerMove(e) {
    if (!dragging || !selectedLayerId) return;
    const lp = currentLayer();
    if (!lp) return;

    const p = svgPointFromEvent(e);
    const dx = p.x - startPtrSvg.x;
    const dy = p.y - startPtrSvg.y;

    if (!dragThresholdMet) {
      const distance = Math.sqrt(dx * dx + dy * dy);
      if (distance < DRAG_THRESHOLD) return;
      
      dragThresholdMet = true;
      pushHistory();
    }

    pendingMove = { dx, dy };

    if (!rafId) {
      rafId = requestAnimationFrame(() => {
        if (pendingMove && lp) {
          lp.tx = startTx + pendingMove.dx;
          lp.ty = startTy + pendingMove.dy;

          updateLayerTransform(lp);
          updateSelectionBox(lp);
          
          cancelAnimationFrame(renderRafId);
          renderRafId = requestAnimationFrame(() => {
            renderFinalPreview();
          });
        }
        rafId = null;
      });
    }

    e.preventDefault();
  }

  let renderRafId = null;

  function handleCanvasPointerUp() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    if (renderRafId) {
      cancelAnimationFrame(renderRafId);
      renderRafId = null;
    }

    if (pendingMove && dragThresholdMet) {
      const lp = currentLayer();
      if (lp) {
        lp.tx = startTx + pendingMove.dx;
        lp.ty = startTy + pendingMove.dy;
        updateLayerTransform(lp);
        updateSelectionBox(lp);
        renderFinalPreview();
      }
    }

    dragging = false;
    dragPointerId = null;
    pendingMove = null;
    dragThresholdMet = false;
    document.body.style.cursor = '';
  }

  let textCreateMode = false;
  let textEditingLayerId = null;

  function ensureTextEditor() {
    const te = document.getElementById('piranha-text-editor-section');
    if (!te) return null;

    if (!document.getElementById('piranha-text-add-confirm')) {
      const btnWrapper = document.getElementById('piranha-text-btn-wrapper');
      const addBtn = document.createElement('button');
      addBtn.id = 'piranha-text-add-confirm';
      addBtn.className = 'piranha-btn piranha-btn-primary';
      addBtn.style.background = '#13668D';
      addBtn.style.borderRadius = '8px';
      addBtn.style.border = 'none';
      addBtn.style.color = 'white';
      addBtn.style.padding = '10px 24px';
      addBtn.style.cursor = 'pointer';
      addBtn.style.fontSize = '14px';
      addBtn.style.fontWeight = '600';
      addBtn.style.whiteSpace = 'nowrap';
      addBtn.textContent = 'Add text';
      if (btnWrapper) {
        btnWrapper.appendChild(addBtn);
      } else {
        te.appendChild(addBtn);
      }

      addBtn.addEventListener('click', () => {
        const input = document.getElementById('piranha-text-input');
        const font = document.getElementById('piranha-font-select');
        const fontWeight = document.getElementById('piranha-font-weight-select');
        const size = document.getElementById('piranha-font-size');
        const color = document.getElementById('piranha-text-color');

        const textValue = (input?.value || 'Your Text').trim() || 'Your Text';
        const fontValue = font?.value || 'Arial';
        const sizeValue = 160;  // Increased from 32
        const colorValue = color?.value || '#000000';
        const weightValue = fontWeight?.value || 'normal';

        if (textCreateMode) {
          const layerId = ++layerIdCounter;
          pushHistory();
          const layerData = {
            id: layerId, type: 'text',
            text: textValue, font: fontValue, size: sizeValue,
            color: colorValue, weight: weightValue,
            tx: 1107, ty: 639, rot: 0, scale: 1, flipX: 1, flipY: 1  // Center of viewBox
          };

          selectedData.designLayers.push(layerData);
          renderLayer(layerData);
      
          renderFinalPreview();
          

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              selectLayer(layerId);
            });
          });
          
          const addTextCheck = document.getElementById('piranha-add-text-check');
          if (addTextCheck) addTextCheck.checked = false;
          te.classList.remove('active');
          textCreateMode = false;
        } else if (selectedLayerId) {
          const lp = currentLayer();
          if (lp && lp.type === 'text') {
            pushHistory();
            lp.text = textValue;
            lp.font = fontValue;
            lp.size = sizeValue;
            lp.color = colorValue;
            lp.weight = weightValue;
            const g = currentLayerGroup();
            const textEl = g?.querySelector('text');
            if (textEl) {
              textEl.textContent = lp.text;
              textEl.setAttribute('font-family', lp.font);
              textEl.setAttribute('font-size', lp.size);
              textEl.setAttribute('fill', lp.color);
              textEl.setAttribute('font-weight', lp.weight);
            }
        
            renderFinalPreview();
            

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                updateSelectionBox(lp);
              });
            });
            
            const addTextCheck = document.getElementById('piranha-add-text-check');
            if (addTextCheck) addTextCheck.checked = false;
            te.classList.remove('active');
          }
        }
      });
    }

    return te;
  }

  function addTextStartFlow() {
    const modal = document.getElementById('piranha-text-modal-overlay');
    const title = document.getElementById('piranha-text-modal-title');
    const confirmBtn = document.getElementById('piranha-text-modal-confirm');
    
    if (!modal) return;
    
    textCreateMode = true;
    modal.classList.add('active');
    
    if (title) title.textContent = 'Add Text';
    if (confirmBtn) confirmBtn.textContent = 'Add Text';
    
    const input = document.getElementById('piranha-modal-text-input');
    const font = document.getElementById('piranha-modal-font-select');
    const fontWeight = document.getElementById('piranha-modal-font-weight-select');
    const color = document.getElementById('piranha-modal-text-color');
    
    if (input) { input.value = ''; input.focus(); }
    if (font) font.value = 'Arial';
    if (fontWeight) fontWeight.value = 'normal';
    if (color) color.value = '#000000';

    syncTextColourUI();
    updateTextModalValidity();
  }

  function updateTextLayerContent(ev) {
    if (textCreateMode) return;
    const lp = currentLayer();
    if (!lp || lp.type !== 'text') return;
    pushHistory();
    lp.text = ev.target.value;
    const g = currentLayerGroup();
    const text = g?.querySelector('text');
    if (text) text.textContent = lp.text;

    updateSelectionBox(lp);
    renderFinalPreview();
  }
  function updateTextLayerFont(ev) {
    if (textCreateMode) return;
    const lp = currentLayer();
    if (!lp || lp.type !== 'text') return;
    pushHistory();
    lp.font = ev.target.value;
    const g = currentLayerGroup();
    const text = g?.querySelector('text');
    if (text) text.setAttribute('font-family', lp.font);
    updateSelectionBox(lp);
    renderFinalPreview();
  }
  function updateTextLayerSize(ev) {
    if (textCreateMode) return;
    const lp = currentLayer();
    if (!lp || lp.type !== 'text') return;
    pushHistory();
    lp.size = parseInt(ev.target.value, 10) || lp.size;
    const g = currentLayerGroup();
    const text = g?.querySelector('text');
    if (text) text.setAttribute('font-size', lp.size);
    updateSelectionBox(lp);
    renderFinalPreview();
  }
  function updateTextLayerColor(ev) {
    if (textCreateMode) return;
    const lp = currentLayer();
    if (!lp || lp.type !== 'text') return;
    pushHistory();
    lp.color = ev.target.value;
    const g = currentLayerGroup();
    const text = g?.querySelector('text');
    if (text) text.setAttribute('fill', lp.color);
    updateSelectionBox(lp);
    renderFinalPreview();
  }

  function updateTextLayerWeight(ev) {
    if (textCreateMode) return;
    const lp = currentLayer();
    if (!lp || lp.type !== 'text') return;
    pushHistory();
    lp.weight = ev.target.value;
    const g = currentLayerGroup();
    const text = g?.querySelector('text');
    if (text) text.setAttribute('font-weight', lp.weight);
    updateSelectionBox(lp);
    renderFinalPreview();
  }

function setupTextModal() {
  const modal = document.getElementById('piranha-text-modal-overlay');
  const closeBtn = document.getElementById('piranha-text-modal-close');
  const cancelBtn = document.getElementById('piranha-text-modal-cancel');
  const confirmBtn = document.getElementById('piranha-text-modal-confirm');
  
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active');
      textCreateMode = false;
    });
  }
  
  if (cancelBtn) {
    cancelBtn.addEventListener('click', () => {
      modal.classList.remove('active');
      textCreateMode = false;
    });
  }
  
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      const input = document.getElementById('piranha-modal-text-input');
      const font = document.getElementById('piranha-modal-font-select');
      const fontWeight = document.getElementById('piranha-modal-font-weight-select');
      const color = document.getElementById('piranha-modal-text-color');
      
      // Belt and braces: the button is disabled while the field is empty, but
      // never take an empty value even if something re-enables it.
      const textValue = (input?.value || '').trim();
      if (!textValue) {
        updateTextModalValidity();
        input?.focus();
        return;
      }

      const fontValue = font?.value || 'Arial';
      const sizeValue = 160;
      const colorValue = color?.value || '#000000';
      const weightValue = fontWeight?.value || 'normal';

      if (textCreateMode) {
        const layerId = ++layerIdCounter;
        pushHistory();
        const layerData = {
          id: layerId, type: 'text',
          text: textValue, font: fontValue, size: sizeValue,
          color: colorValue, weight: weightValue,
          tx: 1107, ty: 639, rot: 0, scale: 1, flipX: 1, flipY: 1
        };

        selectedData.designLayers.push(layerData);
        renderLayer(layerData);
    
        renderFinalPreview();
        
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            selectLayer(layerId);
          });
        });
      } else if (textEditingLayerId) {
        const lp = selectedData.designLayers.find(l => l.id === textEditingLayerId);
        if (lp && lp.type === 'text') {
          pushHistory();
          lp.text = textValue;
          lp.font = fontValue;
          lp.size = sizeValue;
          lp.color = colorValue;
          lp.weight = weightValue;
          
          renderLayer(lp);
          renderFinalPreview();
          
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              updateSelectionBox(lp);
            });
          });
        }
      }
      
      // Clean up once at the end
      modal.classList.remove('active');
      textCreateMode = false;
      textEditingLayerId = null;
    });
  }
  
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.remove('active');
        textCreateMode = false;
      }
    });
  }
  

  const modalTextInput = document.getElementById('piranha-modal-text-input');
  if (modalTextInput) {
    modalTextInput.addEventListener('input', updateTextModalValidity);
    // Enter is the natural way to finish a one-line field; honour it, but only
    // when there's something to add.
    modalTextInput.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      if (modalTextInput.value.trim()) confirmBtn?.click();
    });
  }
  updateTextModalValidity();

  setupCustomFontSelect();
  setupTextColourPalette();
}


function setupCustomFontSelect() {
  const fonts = [
    { value: 'Arial', name: 'Arial' },
    { value: 'Impact', name: 'Impact' },
    { value: 'Times New Roman', name: 'Times New Roman' },
    { value: 'Courier', name: 'Courier' },
    { value: 'Georgia', name: 'Georgia' },
    { value: 'Verdana', name: 'Verdana' },
    { value: 'SuperMario256', name: 'Super Mario' },
    { value: 'Pokemon Hollow', name: 'Pokemon Hollow' },
    { value: 'Pokemon Solid', name: 'Pokemon Solid' },
    { value: 'Ransom', name: 'Ransom' },
    { value: 'Boldstrom', name: 'Boldstrom' },
    { value: 'Blood Hunter', name: 'Blood Hunter' },
    { value: 'Death Bones', name: 'Death Bones' },
    { value: 'Impacted', name: 'Impacted' },
    { value: 'Apple Peach', name: 'Apple Peach' },
    { value: 'Wonderbar Demo', name: 'Wonderbar' },
    { value: 'Made by Tommy', name: 'Made by Tommy' },
    { value: 'Parry Hotter', name: 'Parry Hotter' },
    { value: 'Luckiest Guy', name: 'Luckiest Guy' },
    { value: 'Honey Bear', name: 'Honey Bear' },
    { value: 'Milker', name: 'Milker' },
    { value: 'Wednesday', name: 'Wednesday' },
    { value: 'Attack Of Monster', name: 'Attack Of Monster' },
    { value: 'Frank', name: 'Frank' },
    { value: 'Crackman', name: 'Crackman' },
    { value: 'Green Energy', name: 'Green Energy' },
    { value: 'Moldie', name: 'Moldie' },
    { value: 'Galantic', name: 'Galantic' },
    { value: 'Spooky Ghost', name: 'Spooky Ghost' },
    { value: 'Game of Thrones', name: 'Game of Thrones' },
    { value: 'The Godfather', name: 'The Godfather' },
    { value: 'Analogy', name: 'Analogy' },
    { value: 'Moliga', name: 'Moliga' },
    { value: 'Candy Hunter', name: 'Candy Hunter' }
  ];

  const trigger = document.getElementById('piranha-font-select-trigger');
  const dropdown = document.getElementById('piranha-font-select-dropdown');
  const optionsContainer = document.getElementById('piranha-font-options');
  const hiddenInput = document.getElementById('piranha-modal-font-select');
  const selectedValue = document.querySelector('.piranha-font-select-value');

  if (!trigger || !dropdown || !optionsContainer) return;

  // Generate font options (no filtering needed)
  function renderFontOptions() {
    optionsContainer.innerHTML = '';

    fonts.forEach(font => {
      const option = document.createElement('div');
      option.className = 'piranha-font-option';
      option.dataset.value = font.value;
      option.style.fontFamily = font.value;
      option.textContent = font.name;
      
      option.addEventListener('click', () => {
        hiddenInput.value = font.value;
        selectedValue.textContent = font.name;
        selectedValue.style.fontFamily = font.value;
        dropdown.classList.remove('active');
        trigger.classList.remove('active');
      });
      
      optionsContainer.appendChild(option);
    });
  }

  // Initial render
  renderFontOptions();

  // Toggle dropdown
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('active');
    trigger.classList.toggle('active');
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.classList.remove('active');
      trigger.classList.remove('active');
    }
  });
}

  // Setup colour picker modal
function setupColourPickerModal() {
  const changeColourBtn = document.getElementById('piranha-change-colour-btn');
  const colourModal = document.getElementById('piranha-colour-picker-modal');
  const closeBtn = document.getElementById('piranha-colour-modal-close');
  const colourGrid = document.getElementById('piranha-colour-picker-grid');
  
  if (!changeColourBtn || !colourModal || !colourGrid) return;
  
  // Open modal
  changeColourBtn.addEventListener('click', () => {
    // Populate the grid with colour options
    populateColourGrid();
    colourModal.classList.add('active');
  });
  
  // Close modal
  closeBtn.addEventListener('click', () => {
    colourModal.classList.remove('active');
  });
  
  // Click outside to close
  colourModal.addEventListener('click', (e) => {
    if (e.target === colourModal) {
      colourModal.classList.remove('active');
    }
  });
  
  function populateColourGrid() {
    // Get all colour options from step 2
    const colourOptions = document.querySelectorAll('.piranha-step[data-step="2"] .piranha-colour-option');
    
    // Clear existing options
    colourGrid.innerHTML = '';
    
    // Clone each colour option
    colourOptions.forEach((option) => {
      const clone = option.cloneNode(true);
      const input = clone.querySelector('input[type="radio"]');
      const card = clone.querySelector('.piranha-colour-card, .piranha-colour-card-image');
      
      // Remove checked state
      input.checked = false;
      
      // Highlight current selection
      if (input.value === selectedData.baseColour) {
        input.checked = true;
      }
      
      // Add click handler
      clone.addEventListener('click', () => {
        const colourValue = input.value;
        const colourType = input.dataset.type;
        const colourHex = input.dataset.colour;
        const colourPrice = input.dataset.price;
        const colourImg = input.dataset.img;
        
        // Update selected data
        selectedData.baseColour = colourValue;
        
        if (colourType === 'complex') {
          selectedData.complexDesign = true;
          selectedData.complexDesignPrice = parseInt(colourPrice) || 10;
          selectedData.baseColourHex = '#FFFFFF';
          selectedData.complexDesignImageUrl = colourImg;
        } else {
          selectedData.complexDesign = false;
          selectedData.complexDesignPrice = 0;
          selectedData.baseColourHex = colourHex;
          selectedData.complexDesignImageUrl = null;
        }
        
        // Update the gumshield colour
        updateGumshieldColour(selectedData.baseColourHex);
        
        // Update the selection in step 2
        document.querySelectorAll('.piranha-step[data-step="2"] input[name="base-colour"]').forEach(i => {
          i.checked = i.value === colourValue;
        });
        updateCardOpacity('base-colour');
        
        // Save state
        saveStateToSession();
        updateSummary();
        
        // Close modal
        colourModal.classList.remove('active');
      });
      
      colourGrid.appendChild(clone);
    });
  }
}

  function setupCustomizerListeners() {
    const addTextCheck = document.getElementById('piranha-add-text-check');
    const addTextBtn = document.getElementById('piranha-add-text-btn');
    const addImageBtn = document.getElementById('piranha-add-image-btn');
    const fileInput = document.getElementById('piranha-file-input-canva');
    const canvasLayers = document.getElementById('piranha-canvas-layers');

    if (addTextCheck) {
      addTextCheck.addEventListener('change', function() {
        const textEditorSection = document.getElementById('piranha-text-editor-section');
        if (this.checked) {
          textEditorSection?.classList.add('active');
          addTextStartFlow();
        } else {
          textEditorSection?.classList.remove('active');
          textCreateMode = false;
        }
      });
    }

    if (addTextBtn) {
      addTextBtn.addEventListener('click', () => {
        addTextStartFlow();
      });
    }

    if (addImageBtn) addImageBtn.addEventListener('click', () => {
      if (!fileInput) return;
      var guide = document.getElementById('piranha-image-guide-overlay');
      if (guide) {
        guide.classList.add('active');
      } else {
        fileInput.click();
      }
    });

    (function setupImageGuide() {
      var overlay = document.getElementById('piranha-image-guide-overlay');
      if (!overlay) return;

      function dismiss() { overlay.classList.remove('active'); }

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) dismiss();
      });

      var closeBtn = document.getElementById('piranha-image-guide-close');
      var cancelBtn = document.getElementById('piranha-image-guide-cancel');
      var proceedBtn = document.getElementById('piranha-image-guide-proceed');

      if (closeBtn) closeBtn.addEventListener('click', dismiss);
      if (cancelBtn) cancelBtn.addEventListener('click', dismiss);
      if (proceedBtn) proceedBtn.addEventListener('click', function () {
        dismiss();
        if (fileInput) fileInput.click();
      });
    })();

    if (fileInput) {
      fileInput.addEventListener('change', function (e) {
        const file = e.target.files?.[0];
        if (file && file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = async (ev) => {
            try { await addImageLayer(ev.target.result); }
            catch (err) { console.error('Image upload failed:', err); }
          };
          reader.readAsDataURL(file);
        }
        this.value = '';
      });
    }

    if (canvasLayers) {
      canvasLayers.addEventListener('pointerdown', handleCanvasPointerDown);
      window.addEventListener('pointermove', handleCanvasPointerMove);
      window.addEventListener('pointerup', handleCanvasPointerUp);
    }

    const textInput = document.getElementById('piranha-text-input');
    if (textInput) textInput.addEventListener('input', updateTextLayerContent);
    const fontSelect = document.getElementById('piranha-font-select');
    if (fontSelect) fontSelect.addEventListener('change', updateTextLayerFont);
    const fontWeightSelect = document.getElementById('piranha-font-weight-select');
    if (fontWeightSelect) fontWeightSelect.addEventListener('change', updateTextLayerWeight);
    const fontSize = document.getElementById('piranha-font-size');
    if (fontSize) fontSize.addEventListener('input', updateTextLayerSize);
    const textColor = document.getElementById('piranha-text-color');
    if (textColor) textColor.addEventListener('change', updateTextLayerColor);

    const btnEditText = document.getElementById('piranha-tool-edit-text');
const btnEditTextBottom = document.getElementById('piranha-tool-edit-text-bottom'); // ADD THIS
const btnResize = document.getElementById('piranha-tool-resize');
const btnRotate = document.getElementById('piranha-tool-rotate');
const btnDuplicate = document.getElementById('piranha-tool-duplicate');
const btnDelete = document.getElementById('piranha-tool-delete');
const btnFlipH = document.getElementById('piranha-tool-flip-h');
const btnFlipV = document.getElementById('piranha-tool-flip-v');

if (btnEditText) btnEditText.addEventListener('click', () => {
  if (selectedLayerId) openTextEditorForLayer(selectedLayerId);
});
// ADD THIS - Bottom Edit button
if (btnEditTextBottom) btnEditTextBottom.addEventListener('click', () => {
  if (selectedLayerId) openTextEditorForLayer(selectedLayerId);
});

    if (btnResize) btnResize.addEventListener('click', () => toggleFlyout('resize'));
    if (btnRotate) btnRotate.addEventListener('click', () => toggleFlyout('rotate'));
    if (btnDuplicate) btnDuplicate.addEventListener('click', duplicateLayer);
    if (btnDelete) btnDelete.addEventListener('click', deleteSelectedLayer);
    if (btnFlipH) btnFlipH.addEventListener('click', () => flipLayer('horizontal'));
    if (btnFlipV) btnFlipV.addEventListener('click', () => flipLayer('vertical'));

    const resizeIconHandle = document.getElementById('piranha-resize-icon-handle');
    if (resizeIconHandle) {
      resizeIconHandle.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleFlyout('resize');
      });
    }

    const btnUndo = document.getElementById('piranha-tool-undo');
    const btnRedo = document.getElementById('piranha-tool-redo');
    const btnMoveBack = document.getElementById('piranha-tool-move-back');
    const btnMoveFront = document.getElementById('piranha-tool-move-front');

    if (btnUndo) btnUndo.addEventListener('click', () => {
      undo();
    });
    if (btnRedo) btnRedo.addEventListener('click', () => {
      redo();
    });
   
    if (btnMoveBack) btnMoveBack.addEventListener('click', () => {
      const lp = currentLayer();
      if (!lp) return;
      const idx = selectedData.designLayers.findIndex(l => l.id === lp.id);
      if (idx > 0) {
        pushHistory();
        const temp = selectedData.designLayers[idx];
        selectedData.designLayers[idx] = selectedData.designLayers[idx - 1];
        selectedData.designLayers[idx - 1] = temp;
        rerenderAllLayers();
        selectLayer(lp.id);
        renderFinalPreview();
      }
    });
    if (btnMoveFront) btnMoveFront.addEventListener('click', () => {
      const lp = currentLayer();
      if (!lp) return;
      const idx = selectedData.designLayers.findIndex(l => l.id === lp.id);
      if (idx > -1 && idx < selectedData.designLayers.length - 1) {
        pushHistory();
        const temp = selectedData.designLayers[idx];
        selectedData.designLayers[idx] = selectedData.designLayers[idx + 1];
        selectedData.designLayers[idx + 1] = temp;
        rerenderAllLayers();
        selectLayer(lp.id);
        renderFinalPreview();
      }
    });

const closeResize = document.querySelector('[data-close="resize"]');
const closeRotate = document.querySelector('[data-close="rotate"]');

if (closeResize) closeResize.addEventListener('click', () => {
  if (flyResizeEl) {
    flyResizeEl.style.display = 'none';
    const canvasContainer = document.getElementById('piranha-canvas-container');
    const bottomToolbar = document.getElementById('piranha-bottom-toolbar');
    if (canvasContainer) {
      canvasContainer.classList.remove('flyout-active');
    }
    if (bottomToolbar) {
      bottomToolbar.classList.remove('flyout-active');
    }
  }
});

if (closeRotate) closeRotate.addEventListener('click', () => {
  if (flyRotateEl) {
    flyRotateEl.style.display = 'none';
    const canvasContainer = document.getElementById('piranha-canvas-container');
    const bottomToolbar = document.getElementById('piranha-bottom-toolbar');
    if (canvasContainer) {
      canvasContainer.classList.remove('flyout-active');
    }
    if (bottomToolbar) {
      bottomToolbar.classList.remove('flyout-active');
    }
  }
});

    if (resizeSliderEl && resizeValueEl) {
  let resizingWithSlider = false;
  const onResize = (e) => {
    const val = parseInt(e.target.value, 10);
    resizeSliderEl.value = resizeValueEl.value = val;
    const lp = currentLayer(); if (!lp) return;
    if (!resizingWithSlider) { pushHistory(); resizingWithSlider = true; }
    lp.scale = Math.max(0.1, val / 100);
    updateLayerTransform(lp);
    
    // Use RAF to ensure transform is applied before updating selection box
    requestAnimationFrame(() => {
      updateSelectionBox(lp);
    });
    
    renderFinalPreview();
  };
      const endResizeCommit = () => { resizingWithSlider = false; };
      resizeSliderEl.addEventListener('input', onResize);
      resizeValueEl.addEventListener('input', onResize);
      resizeSliderEl.addEventListener('change', endResizeCommit);
      resizeValueEl.addEventListener('change', endResizeCommit);
    }

    if (rotateSliderEl && rotateValueEl) {
      let rotatingWithSlider = false;
      const onRotate = (e) => {
        const val = parseFloat(e.target.value);
        rotateSliderEl.value = rotateValueEl.value = val;
        const lp = currentLayer(); if (!lp) return;
        if (!rotatingWithSlider) { pushHistory(); rotatingWithSlider = true; }
        lp.rot = val;
        updateLayerTransform(lp);
        updateSelectionBox(lp);
        renderFinalPreview();
      };
      const endRotateCommit = () => { rotatingWithSlider = false; };
      rotateSliderEl.addEventListener('input', onRotate);
      rotateValueEl.addEventListener('input', onRotate);
      rotateSliderEl.addEventListener('change', endRotateCommit);
      rotateValueEl.addEventListener('change', endRotateCommit);
    }

    document.addEventListener('click', (e) => {
  // Check if clicking on toolbar, flyouts, or layer items
  if (e.target.closest('#piranha-top-toolbar') ||
      e.target.closest('#piranha-flyout-resize') ||
      e.target.closest('#piranha-flyout-rotate') ||
      e.target.closest('.piranha-layer-item')) {
    return;
  }
  
  // If clicking inside canvas container but not on a layer, deselect
  if (e.target.closest('#piranha-canvas-container')) {
    const clickedLayer = e.target.closest('[data-layer-id]');
    if (!clickedLayer) {
      deselectLayer();
      hideFlyouts();
    }
    return;
  }
  
  // Clicking outside everything - deselect and hide flyouts
  deselectLayer();
  hideFlyouts();
});

    setupCornerHandleResize();
    setupRotationHandle();
    setupMoveHandle();

   window.addEventListener('resize', () => {
  const lp = currentLayer();
  if (lp) updateSelectionBox(lp);
  
  // Remove flyout-active class on desktop
  const canvasContainer = document.getElementById('piranha-canvas-container');
  if (canvasContainer && window.innerWidth > 768) {
    canvasContainer.classList.remove('flyout-active');
  }
});

    document.addEventListener('keydown', (e) => {
      const z = e.key.toLowerCase() === 'z';
      const y = e.key.toLowerCase() === 'y';
      if ((e.ctrlKey || e.metaKey) && z && !e.shiftKey) { e.preventDefault(); undo(); }
      if (((e.ctrlKey || e.metaKey) && y) || ((e.ctrlKey || e.metaKey) && e.shiftKey && z)) { e.preventDefault(); redo(); }
    });
  }

  function setupCornerHandleResize() {
    let resizing = false;
    let resizeHandle = null;
    let startPointerPos = null;
    let startScale = 1;
    let startWidth = 0;
    let startHeight = 0;
    let layerCenter = null;

    const handles = document.querySelectorAll('.piranha-resize-handle');
    handles.forEach(handle => {
      handle.addEventListener('pointerdown', startResize);
    });

    function startResize(e) {
      e.stopPropagation();
      e.preventDefault();

      const lp = currentLayer();
      if (!lp) return;

      pushHistory();

      resizing = true;
      resizeHandle = e.target.dataset.handle;
      startScale = lp.scale || 1;

      const g = currentLayerGroup();
      if (!g) return;
      
      const bb = g.getBBox();
      startWidth = bb.width * Math.abs(startScale * (lp.flipX || 1));
      startHeight = bb.height * Math.abs(startScale * (lp.flipY || 1));

      const m = g.getScreenCTM();
      const centerX = bb.x + bb.width / 2;
      const centerY = bb.y + bb.height / 2;
      const centerPoint = svgEl.createSVGPoint();
      centerPoint.x = centerX;
      centerPoint.y = centerY;
      const transformedCenter = centerPoint.matrixTransform(m);
      layerCenter = { x: transformedCenter.x, y: transformedCenter.y };

      startPointerPos = { x: e.clientX, y: e.clientY };

      document.addEventListener('pointermove', handleResize);
      document.addEventListener('pointerup', stopResize);
      
      handle.setPointerCapture?.(e.pointerId);
    }

    function handleResize(e) {
      if (!resizing || !selectedLayerId) return;

      const lp = currentLayer();
      if (!lp) return;

      const dx = e.clientX - layerCenter.x;
      const dy = e.clientY - layerCenter.y;
      
      const currentDist = Math.sqrt(dx * dx + dy * dy);
      
      const initialDx = startPointerPos.x - layerCenter.x;
      const initialDy = startPointerPos.y - layerCenter.y;
      const initialDist = Math.sqrt(initialDx * initialDx + initialDy * initialDy);

      if (initialDist > 0) {
        const scaleFactor = currentDist / initialDist;
        lp.scale = Math.max(0.1, startScale * scaleFactor);

        updateLayerTransform(lp);
        updateSelectionBox(lp);
        
        if (resizeSliderEl && resizeValueEl) {
          const scalePct = Math.round(lp.scale * 100);
          resizeSliderEl.value = scalePct;
          resizeValueEl.value = scalePct;
        }
        
        renderFinalPreview();
      }

      e.preventDefault();
    }

    function stopResize(e) {
      if (!resizing) return;
      
      resizing = false;
      resizeHandle = null;
      startPointerPos = null;
      layerCenter = null;

      document.removeEventListener('pointermove', handleResize);
      document.removeEventListener('pointerup', stopResize);
    }
  }

  function setupRotationHandle() {
    let rotating = false;
    let startAngle = 0;
    let startRotation = 0;
    let layerCenter = null;

    const rotateHandle = document.querySelector('.piranha-rotate-handle');
    if (rotateHandle) {
      rotateHandle.addEventListener('pointerdown', startRotate);
    }

    function startRotate(e) {
      e.stopPropagation();
      e.preventDefault();

      const lp = currentLayer();
      if (!lp) return;

      pushHistory();

      rotating = true;
      startRotation = lp.rot || 0;

      const g = currentLayerGroup();
      if (!g) return;
      
      const bb = g.getBBox();
      const m = g.getScreenCTM();
      const centerX = bb.x + bb.width / 2;
      const centerY = bb.y + bb.height / 2;
      const centerPoint = svgEl.createSVGPoint();
      centerPoint.x = centerX;
      centerPoint.y = centerY;
      const transformedCenter = centerPoint.matrixTransform(m);
      layerCenter = { x: transformedCenter.x, y: transformedCenter.y };

      const dx = e.clientX - layerCenter.x;
      const dy = e.clientY - layerCenter.y;
      startAngle = Math.atan2(dy, dx) * (180 / Math.PI);

      document.addEventListener('pointermove', handleRotate);
      document.addEventListener('pointerup', stopRotate);
      
      rotateHandle.setPointerCapture?.(e.pointerId);
    }

    function handleRotate(e) {
      if (!rotating || !selectedLayerId) return;

      const lp = currentLayer();
      if (!lp) return;

      const dx = e.clientX - layerCenter.x;
      const dy = e.clientY - layerCenter.y;
      const currentAngle = Math.atan2(dy, dx) * (180 / Math.PI);

      const angleDelta = currentAngle - startAngle;
      lp.rot = startRotation + angleDelta;

      while (lp.rot > 180) lp.rot -= 360;
      while (lp.rot < -180) lp.rot += 360;

      updateLayerTransform(lp);
      updateSelectionBox(lp);
      
      if (rotateSliderEl && rotateValueEl) {
        rotateSliderEl.value = lp.rot;
        rotateValueEl.value = lp.rot;
      }
      
      renderFinalPreview();

      e.preventDefault();
    }

    function stopRotate(e) {
      if (!rotating) return;
      
      rotating = false;
      startAngle = 0;
      layerCenter = null;

      document.removeEventListener('pointermove', handleRotate);
      document.removeEventListener('pointerup', stopRotate);
    }
  }

  function setupMoveHandle() {
    let moving = false;
    let movePointerId = null;
    let startSvgPoint = null;
    let startTx = 0;
    let startTy = 0;

    const moveHandle = document.querySelector('.piranha-move-handle');
    if (moveHandle) {
      moveHandle.addEventListener('pointerdown', startMove);
    }

    function startMove(e) {
      e.stopPropagation();
      e.preventDefault();

      const lp = currentLayer();
      if (!lp) return;

      pushHistory();

      moving = true;
      movePointerId = e.pointerId;
      moveHandle.setPointerCapture?.(movePointerId);

      startSvgPoint = svgPointFromEvent(e);
      startTx = lp.tx || 0;
      startTy = lp.ty || 0;

      document.addEventListener('pointermove', handleMove);
      document.addEventListener('pointerup', stopMove);
    }

    function handleMove(e) {
      if (!moving || !selectedLayerId) return;

      const lp = currentLayer();
      if (!lp) return;

      const currentSvgPoint = svgPointFromEvent(e);
      const dx = currentSvgPoint.x - startSvgPoint.x;
      const dy = currentSvgPoint.y - startSvgPoint.y;

      lp.tx = startTx + dx;
      lp.ty = startTy + dy;

      updateLayerTransform(lp);
      updateSelectionBox(lp);
      renderFinalPreview();

      e.preventDefault();
    }

    function stopMove(e) {
      if (!moving) return;
      
      moving = false;
      movePointerId = null;
      startSvgPoint = null;

      document.removeEventListener('pointermove', handleMove);
      document.removeEventListener('pointerup', stopMove);
    }
  }

  function hideFlyouts() {
  if (flyResizeEl) flyResizeEl.style.display = 'none';
  if (flyRotateEl) flyRotateEl.style.display = 'none';
  
  // CRITICAL: Remove the push-down class when hiding flyouts
  const canvasContainer = document.getElementById('piranha-canvas-container');
  const bottomToolbar = document.getElementById('piranha-bottom-toolbar');
  if (canvasContainer) {
    canvasContainer.classList.remove('flyout-active');
  }
  if (bottomToolbar) {
    bottomToolbar.classList.remove('flyout-active');
  }
}

function toggleFlyout(which) {
  if (!topToolbarEl) return;
  
  const fly = which === 'resize' ? flyResizeEl : flyRotateEl;
  const other = which === 'resize' ? flyRotateEl : flyResizeEl;
  const canvasContainer = document.getElementById('piranha-canvas-container');
  const bottomToolbar = document.getElementById('piranha-bottom-toolbar');

  if (!fly) return;
  
  // Close other flyout
  if (other) {
    other.style.display = 'none';
  }

  // Toggle current flyout
  if (fly.style.display === 'block') {
    fly.style.display = 'none';
    // Remove push-down class when closing
    if (canvasContainer) {
      canvasContainer.classList.remove('flyout-active');
    }
    if (bottomToolbar) {
      bottomToolbar.classList.remove('flyout-active');
    }
  } else {
    // Get toolbar height to position flyout directly below it
    const toolbarRect = topToolbarEl.getBoundingClientRect();
    const toolbarHeight = toolbarRect.height;
    
    // Position directly below toolbar
    fly.style.position = 'absolute';
    fly.style.left = '50%';
    fly.style.transform = 'translateX(-50%)';
    fly.style.top = (toolbarHeight + 4) + 'px';
    fly.style.bottom = 'auto';
    fly.style.display = 'block';
    
    // Add push-down class when opening - WORKS ON DESKTOP AND MOBILE
    if (canvasContainer) {
      canvasContainer.classList.add('flyout-active');
    }
    if (bottomToolbar) {
      bottomToolbar.classList.add('flyout-active');
    }
  }
}

  function nextStep() {
    if (!validateCurrentStep()) return;
    
    if (currentStep === totalSteps) {
      proceedToCheckout();
      return;
    }
    
    if (currentStep < totalSteps) {
      currentStep++;
      
      if (currentStep === 2 && selectedData.designChoice === 'predesign') {
        currentStep++;
      }
      if (currentStep === 3 && (selectedData.complexDesign || selectedData.designChoice === 'predesign')) {
        currentStep++;
      }
      
      saveStateToSession();
      updateStep();
    }
  }

  function prevStep() {
    if (currentStep > 0) {
      currentStep--;
      
      if (currentStep === 3 && (selectedData.complexDesign || selectedData.designChoice === 'predesign')) {
        currentStep--;
      }
      if (currentStep === 2 && selectedData.designChoice === 'predesign') {
        currentStep--;
      }
      
      saveStateToSession();
      updateStep();
    }
  }

  function updateStep() {
    document.querySelectorAll('.piranha-step').forEach(s => s.classList.remove('active'));
    const activeStep = document.querySelector(`.piranha-step[data-step="${currentStep}"]`);
    if (activeStep) activeStep.classList.add('active');
    updateProgress();
    updateNavigationButtons();
    
    const modalContent = document.querySelector('.piranha-modal-content');
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
    
    const stepsContainer = document.querySelector('.piranha-steps-container');
    if (stepsContainer) {
      stepsContainer.scrollTop = 0;
    }
    
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (currentStep === 6) {
      updateSummary();
      renderFinalPreview();
      const kitDeliveryDateEl = document.getElementById('piranha-kit-delivery-date');
      if (kitDeliveryDateEl) {
        kitDeliveryDateEl.style.display = selectedData.impressionMethod === 'impression-kit' ? 'flex' : 'none';
      }
    }
  }

  function updateProgress() {
    const progressWrapper = document.querySelector('.piranha-progress-wrapper');
    
    if (currentStep === 0) {
      if (progressWrapper) progressWrapper.style.display = 'none';
      return;
    } else {
      if (progressWrapper) progressWrapper.style.display = 'block';
    }

    if (progressWrapper) {
      progressWrapper.style.display = 'none';
    }
    return;
  }

  function updateNavigationButtons() {
  const backBtn = document.getElementById('piranha-back-btn');
  const nextBtn = document.getElementById('piranha-next-btn');
  if (backBtn) backBtn.style.display = currentStep > 0 ? 'inline-flex' : 'none';
  if (nextBtn) {
    nextBtn.textContent = currentStep === totalSteps ? 'Checkout' : 'Next';
    
    // Don't disable button, but change color based on validation
    nextBtn.disabled = false;
    const isValid = validateCurrentStepSilent();
    nextBtn.style.background = isValid ? '#000000' : '#535353';
    nextBtn.style.cursor = isValid ? 'pointer' : 'not-allowed';
  }
}

  function validateCurrentStepSilent() {
  if (currentStep === 0 && !selectedData.impressionMethod) return false;
  if (currentStep === 0 && selectedData.impressionMethod === 'dental-scan' &&
      !(window.piranhaScanFiles && window.piranhaScanFiles.length > 0)) return false;
  if (currentStep === 1) {
    if (!selectedData.designChoice) return false;
    if (selectedData.designChoice === 'predesign' && !selectedData.selectedPredesign) return false;
  }
  if (currentStep === 2 && selectedData.designChoice === 'custom' && !selectedData.baseColour) return false;
  if (currentStep === 4 && !selectedData.storageCase) return false;
  return true;
}

  function validateCurrentStep() {
  if (currentStep === 0 && !selectedData.impressionMethod) {
    showPiranhaToast('Please select an impression method');
    return false;
  }
  if (currentStep === 0 && selectedData.impressionMethod === 'dental-scan' &&
      !(window.piranhaScanFiles && window.piranhaScanFiles.length > 0)) {
    showPiranhaToast('Please upload at least one dental scan file (STL, PLY, or OBJ) before continuing.');
    return false;
  }
  if (currentStep === 1) {
    if (!selectedData.designChoice) { 
      showPiranhaToast('Please choose whether to customise your own design or select from our library'); 
      return false; 
    }
    if (selectedData.designChoice === 'predesign' && !selectedData.selectedPredesign) { 
      showPiranhaToast('Please select a design from the library'); 
      return false; 
    }
  }
  if (currentStep === 2 && selectedData.designChoice === 'custom' && !selectedData.baseColour) { 
    showPiranhaToast('Please select a colour'); 
    return false; 
  }
  if (currentStep === 4 && !selectedData.storageCase) { 
    showPiranhaToast('Please select a storage case'); 
    return false; 
  }
  return true;
}

  // Tracks whether files are currently being uploaded to Supabase. While
  // true, every modal-dismissal path is a no-op and the loader overlay is
  // shown. A premature dismiss here was leaving customers with a paid
  // order but no design files attached.
  function setUploading(active, title, subtitle) {
    window.piranhaUploading = !!active;
    const overlay = document.getElementById('piranha-uploading-overlay');
    const content = document.querySelector('.piranha-modal-content');
    if (overlay) {
      overlay.classList.toggle('active', !!active);
      overlay.setAttribute('aria-hidden', active ? 'false' : 'true');
    }
    if (content) content.classList.toggle('is-uploading', !!active);
    if (active && title) {
      const t = document.getElementById('piranha-uploading-title');
      if (t) t.textContent = title;
    }
    if (active && subtitle) {
      const s = document.getElementById('piranha-uploading-subtitle');
      if (s) s.textContent = subtitle;
    }
  }

  function closeModal() {
  if (window.piranhaUploading) return;
  const modal = document.getElementById('piranha-modal');
  if (modal) {
    modal.classList.remove('active');
  }
  
  // CRITICAL: Force remove ALL scroll-blocking
  document.body.classList.remove('piranha-modal-open');
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
  document.body.style.height = '';
  document.body.style.touchAction = '';
  
  document.documentElement.style.overflow = '';
  document.documentElement.style.position = '';
  document.documentElement.style.overscrollBehavior = '';
  document.documentElement.style.touchAction = '';
  
  if (currentStep === 3) {
    document.body.style.setProperty('overflow', 'auto', 'important');
    document.body.style.setProperty('position', 'static', 'important');
    document.body.style.setProperty('touch-action', 'auto', 'important');
    document.documentElement.style.setProperty('overflow', 'auto', 'important');
    void document.body.offsetHeight;
  }
  
  // Save state when closing - DON'T reset
  saveStateToSession();
}

  function updateGumshieldColour(colour) {
    const canvasBg = document.getElementById('piranha-canvas-bg');
    if (canvasBg) canvasBg.setAttribute('fill', colour);
    const insideBase = document.getElementById('piranha-inside-base');
    if (insideBase) insideBase.setAttribute('fill', colour);
    const finalBase = document.getElementById('piranha-final-base');
    if (finalBase) finalBase.setAttribute('fill', colour);
    // Keep the base-colour border frames matching the base colour so they blend
    // into the border instead of showing as a coloured ring.
    const borderFrame = document.getElementById('piranha-border-frame');
    if (borderFrame) borderFrame.setAttribute('stroke', colour);
    const finalBorderFrame = document.getElementById('piranha-final-border-frame');
    if (finalBorderFrame) finalBorderFrame.setAttribute('stroke', colour);
  }

  function updateInsideNamePreview() {
    const nameText = document.getElementById('piranha-inside-name-text');
    const text = selectedData.nameText || 'YOUR NAME';
    const fontMap = {
      'arial': 'Arial',
      'impact': 'Impact',
      'times': 'Times New Roman',
      'courier': 'Courier',
      'script': 'Brush Script MT, cursive',
      'supermario256': 'SuperMario256',
      'pokemonsolid': 'Pokemon Solid',
      'pokemonhollow': 'Pokemon Hollow',
      'ransom': 'Ransom',
      'boldstrom': 'Boldstrom',
      'bloodhunter': 'Blood Hunter',
      'deathbones': 'Death Bones',
      'impacted': 'Impacted',
      'applepeach': 'Apple Peach',
      'wonderbar': 'Wonderbar Demo',
      'madebytommy': 'Made by Tommy',
      'parryhotter': 'Parry Hotter',
      'luckiestguy': 'Luckiest Guy',
      'honeybear': 'Honey Bear',
      'milker': 'Milker',
      'wednesday': 'Wednesday',
      'attackofmonster': 'Attack Of Monster',
      'frank': 'Frank',
      'crackman': 'Crackman',
      'greenenergy': 'Green Energy',
      'moldie': 'Moldie',
      'galantic': 'Galantic',
      'spookyghost': 'Spooky Ghost',
      'gameofthrones': 'Game of Thrones',
      'thegodfather': 'The Godfather',
      'analogy': 'Analogy',
      'moliga': 'Moliga',
      'candyhunter': 'Candy Hunter'
    };
    const sizeMap = { 'small': 20, 'medium': 24, 'large': 28 };

    if (nameText) {
      nameText.textContent = text.toUpperCase();
      nameText.setAttribute('font-family', fontMap[selectedData.nameFont] || 'Arial');
      nameText.setAttribute('font-size', sizeMap[selectedData.nameSize] || 24);
      nameText.setAttribute('fill', selectedData.nameColor || '#FFFFFF');
      nameText.setAttribute('font-weight', selectedData.nameWeight || 'normal');
    }
  }

  // ── Colour legibility ─────────────────────────────────────────────────────
  // Anything printed on the gumshield — design text layers, the inside name tag
  // — disappears when its colour sits too close to the base colour. This is a
  // perceptual judgement, not an equality test: white on Turquoise is just as
  // unreadable as white on White, so compare contrast, not hex values. Warn,
  // never block; a customer may genuinely want a barely-there design.
  const PIRANHA_MIN_CONTRAST = 2.0; // WCAG contrast ratio; 1.0 = identical

  // Mirrors the palette in the Text Colour tiles so warnings and the readout can
  // say "White" instead of "#FFFFFF".
  const PIRANHA_INK_NAMES = {
    '#000000': 'Black', '#FFFFFF': 'White', '#1D2D6B': 'Navy Blue',
    '#36BF4D': 'Green', '#FEA1C1': 'Baby Pink', '#BFA53A': 'Gold',
    '#7C061F': 'Maroon', '#F06900': 'Orange', '#8C0059': 'Purple',
    '#00441E': 'Dark Green', '#F13622': 'Red', '#0055E5': 'Royal Blue',
    '#9B9BAE': 'Silver', '#59E1EF': 'Sky Blue', '#00FED7': 'Turquoise'
  };

  // Accepts #rgb, #rrggbb and rgb()/rgba() — the Clear base is stored as
  // rgba(255,255,255,0.3), and a white tag is just as invisible on it. Alpha is
  // ignored: a translucent white base still reads as white here.
  function piranhaColourToRgb(value) {
    const raw = String(value || '').trim();
    const rgbMatch = raw.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (rgbMatch) {
      const parts = [rgbMatch[1], rgbMatch[2], rgbMatch[3]].map(Number);
      return parts.every((n) => n >= 0 && n <= 255) ? parts : null;
    }
    let h = raw.replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6 || !/^[0-9a-f]{6}$/i.test(h)) return null;
    return [h.slice(0, 2), h.slice(2, 4), h.slice(4, 6)].map((p) => parseInt(p, 16));
  }

  function piranhaLuminance(colour) {
    const rgb = piranhaColourToRgb(colour);
    if (!rgb) return null;
    const channel = (v) => {
      const s = v / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * channel(rgb[0]) + 0.7152 * channel(rgb[1]) + 0.0722 * channel(rgb[2]);
  }

  function piranhaContrastRatio(hexA, hexB) {
    const a = piranhaLuminance(hexA), b = piranhaLuminance(hexB);
    if (a === null || b === null) return null;
    return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
  }

  // Complex designs carry arbitrary artwork and only use baseColourHex as a white
  // placeholder, so there's no single colour to compare anything against.
  function piranhaBaseColourForContrast() {
    if (selectedData.complexDesign) return null;
    return selectedData.baseColourHex || null;
  }

  function piranhaBaseColourLabel() {
    return (selectedData.baseColour || 'chosen')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }

  function piranhaColourName(value) {
    const raw = String(value || '').trim();
    if (/^rgba?\(\s*255\s*,\s*255\s*,\s*255/i.test(raw)) return 'Clear';
    const key = raw.startsWith('#') ? '#' + raw.slice(1).toUpperCase() : raw.toUpperCase();
    return PIRANHA_INK_NAMES[key] || key;
  }

  // True when `colour` would be all but invisible on the current base colour.
  function piranhaColourIsInvisibleOnBase(colour) {
    const base = piranhaBaseColourForContrast();
    if (!base || !colour) return false;
    const ratio = piranhaContrastRatio(base, colour);
    return ratio !== null && ratio < PIRANHA_MIN_CONTRAST;
  }

  // ── Add / Edit Text validation ────────────────────────────────────────────
  // An empty field used to be accepted and silently added a layer reading "Your
  // Text", which customers then had to find and delete. Gate the button on there
  // being something to add.
  function updateTextModalValidity() {
    const input = document.getElementById('piranha-modal-text-input');
    const confirmBtn = document.getElementById('piranha-text-modal-confirm');
    const hint = document.getElementById('piranha-text-modal-hint');
    const isEmpty = !(input && input.value.trim());

    if (confirmBtn) {
      confirmBtn.disabled = isEmpty;
      confirmBtn.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
    }
    if (hint) hint.hidden = !isEmpty;
  }

  // ── Text colour palette (Add / Edit Text modal) ───────────────────────────
  // The preset tiles and the Custom input both feed #piranha-modal-text-color;
  // everything downstream keeps reading that one input, so nothing else in the
  // modal had to change.
  function currentModalTextColour() {
    const input = document.getElementById('piranha-modal-text-color');
    return input ? input.value : '#000000';
  }

  function syncTextColourUI() {
    const grid = document.getElementById('piranha-text-colour-grid');
    const colour = currentModalTextColour();
    const normalised = String(colour || '').toUpperCase();

    let matchedPreset = false;
    if (grid) {
      grid.querySelectorAll('.piranha-text-colour-tile[data-colour]').forEach((tile) => {
        const isActive = String(tile.dataset.colour || '').toUpperCase() === normalised;
        tile.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) matchedPreset = true;
      });
      // The Custom tile only reads as selected when the colour isn't a preset,
      // so exactly one tile is ever highlighted.
      const customTile = grid.querySelector('.piranha-text-colour-tile--custom');
      if (customTile) customTile.classList.toggle('is-active', !matchedPreset);
    }

    const readout = document.getElementById('piranha-text-colour-readout');
    if (readout) readout.textContent = piranhaColourName(colour);

    updateTextColourWarning();
  }

  function updateTextColourWarning() {
    const warning = document.getElementById('piranha-text-colour-warning');
    if (!warning) return;

    const colour = currentModalTextColour();
    if (!piranhaColourIsInvisibleOnBase(colour)) {
      warning.hidden = true;
      return;
    }

    const message = document.getElementById('piranha-text-colour-warning-text');
    if (message) {
      message.textContent = piranhaColourName(colour) + ' text will barely show on a ' +
        piranhaBaseColourLabel() + ' gumshield. Choose another colour, or continue as is.';
    }
    warning.hidden = false;
  }

  function setupTextColourPalette() {
    const grid = document.getElementById('piranha-text-colour-grid');
    const input = document.getElementById('piranha-modal-text-color');
    if (!grid || !input) return;

    grid.querySelectorAll('.piranha-text-colour-tile[data-colour]').forEach((tile) => {
      tile.addEventListener('click', function () {
        input.value = this.dataset.colour;
        syncTextColourUI();
      });
    });

    // 'input' as well as 'change' so the warning tracks the native picker while
    // the customer is still dragging around inside it.
    input.addEventListener('input', syncTextColourUI);
    input.addEventListener('change', syncTextColourUI);

    syncTextColourUI();
  }

  // ── Design text legibility on the canvas ──────────────────────────────────
  // The modal warning only covers the colour being picked right now. This covers
  // what's already on the mouthguard, so a customer who dismissed the modal — or
  // changed the base colour afterwards — still sees it.
  function updateCanvasTextWarning() {
    const warning = document.getElementById('piranha-canvas-text-warning');
    if (!warning) return;

    const layers = (selectedData.designLayers || []).filter(
      (l) => l.type === 'text' && piranhaColourIsInvisibleOnBase(l.color)
    );
    if (layers.length === 0) {
      warning.hidden = true;
      return;
    }

    const message = document.getElementById('piranha-canvas-text-warning-text');
    if (message) {
      const baseLabel = piranhaBaseColourLabel();
      message.textContent = layers.length === 1
        ? 'Your ' + piranhaColourName(layers[0].color) + ' text will barely show on a ' +
          baseLabel + ' gumshield. Tap it, then Edit, to change the colour — or continue as is.'
        : layers.length + ' text layers will barely show on a ' + baseLabel +
          ' gumshield. Tap each one, then Edit, to change the colour — or continue as is.';
    }
    warning.hidden = false;
  }

  function renderFinalPreview() {

  // At the top, not the bottom: this function returns early on several paths,
  // and layer state is already up to date by the time callers reach it.
  updateCanvasTextWarning();

  const finalLayers = document.getElementById('piranha-final-layers');
  const finalBase = document.getElementById('piranha-final-base');
  const finalSvg = document.querySelector('.piranha-final-preview-svg');
  const svgOutline = finalSvg?.querySelector('path[fill="none"][stroke="#333"]');
  
  if (!finalLayers) return;
  finalLayers.innerHTML = '';
    
    // Prebuilt designs are finished mouthguard artwork — show them as a plain
    // flat image (no SVG mouthguard clip / outline / border), same as the complex
    // custom-design image preview.
    const isPredesignPreview =
      selectedData.designChoice === 'predesign' && selectedData.selectedPredesignImage;
    const shouldShowImagePreview =
      (selectedData.designChoice === 'custom' && selectedData.complexDesign && selectedData.complexDesignImageUrl)
      || isPredesignPreview;
    
    if (shouldShowImagePreview) {
      if (svgOutline) {
        svgOutline.style.display = 'none';
      }
      
      const previewContainer = document.querySelector('.piranha-summary-preview');
      if (previewContainer) {
        if (finalSvg) finalSvg.style.display = 'none';

        let imgWrapper = previewContainer.querySelector('.piranha-complex-preview-wrapper');
        if (!imgWrapper) {
          imgWrapper = document.createElement('div');
          imgWrapper.className = 'piranha-complex-preview-wrapper';
          
          imgWrapper.style.width = '100%';
          imgWrapper.style.maxWidth = '600px';
          imgWrapper.style.height = '200px';
          imgWrapper.style.overflow = 'hidden'; 
          imgWrapper.style.borderRadius = '12px';
          imgWrapper.style.margin = '0 auto';
          imgWrapper.style.display = 'block';

          let imgPreview = document.createElement('img');
          imgPreview.className = 'piranha-complex-preview-img';
          imgPreview.style.width = '100%';
          imgPreview.style.height = '100%';
          imgPreview.style.objectFit = 'cover';

          imgWrapper.appendChild(imgPreview);
          previewContainer.appendChild(imgWrapper);
        }

        let imgPreview = imgWrapper.querySelector('.piranha-complex-preview-img');
        
        if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesignImage) {
          imgPreview.src = selectedData.selectedPredesignImage;
          imgPreview.alt = 'Pre-designed Gumshield: ' + selectedData.selectedPredesign;
          // Frame the finished mouthguard artwork, trimming its surrounding
          // whitespace — no SVG mouthguard clip, outline or border.
          imgPreview.style.objectFit = 'cover';
        } else {
          imgPreview.src = selectedData.complexDesignImageUrl;
          imgPreview.alt = 'Your Gumshield Design';
          imgPreview.style.objectFit = 'cover';
        }
      }
      return;
    } else {
      const previewWrapper = document.querySelector('.piranha-complex-preview-wrapper');
      if (previewWrapper) {
        previewWrapper.remove();
      }
      
      if (svgOutline) {
        svgOutline.style.display = 'block';
      }
      
      if (finalSvg) finalSvg.style.display = 'block';
      const imgPreview = document.querySelector('.piranha-complex-preview-img');
      if (imgPreview) imgPreview.remove();
    }
    
    if (finalBase && selectedData.complexDesign && selectedData.complexDesignImageUrl) {
      const parentGroup = finalBase.parentNode;
      const newImage = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      newImage.setAttribute('id', 'piranha-final-base');
      newImage.setAttribute('x', '0');
      newImage.setAttribute('y', '0');
      newImage.setAttribute('width', '2214');
      newImage.setAttribute('height', '1278');
      newImage.setAttributeNS('http://www.w3.org/1999/xlink', 'href', selectedData.complexDesignImageUrl);
      newImage.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      parentGroup.replaceChild(newImage, finalBase);
    } else if (finalBase && !selectedData.complexDesign) {
      if (finalBase.tagName !== 'rect') {
        const parentGroup = finalBase.parentNode;
        const newRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        newRect.setAttribute('id', 'piranha-final-base');
        newRect.setAttribute('x', '0');
        newRect.setAttribute('y', '0');
        newRect.setAttribute('width', '2214');
        newRect.setAttribute('height', '1278');
        newRect.setAttribute('fill', selectedData.baseColourHex || '#FF0000');
        parentGroup.replaceChild(newRect, finalBase);
      } else {
        finalBase.setAttribute('fill', selectedData.baseColourHex || '#FF0000');
      }
    }

    // Prebuilt designs are pre-composed artwork and must render exactly as the
    // customer saw them in the library: clipped to the original printable area
    // (front-area-clip-final) with NO uniform border frame. The border frame and
    // whole-shape fill are only for custom designs, so hide the frame here.
    const finalBorderFrame = document.getElementById('piranha-final-border-frame');
    if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesignImage) {
      if (finalBorderFrame) finalBorderFrame.style.display = 'none';
      const predesignImg = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      predesignImg.setAttribute('x', '0');
      predesignImg.setAttribute('y', '0');
      predesignImg.setAttribute('width', '2214');
      predesignImg.setAttribute('height', '1278');
      predesignImg.setAttributeNS('http://www.w3.org/1999/xlink', 'href', selectedData.selectedPredesignImage);
      predesignImg.setAttribute('href', selectedData.selectedPredesignImage);
      predesignImg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      predesignImg.setAttribute('clip-path', 'url(#front-area-clip-final)');
      finalLayers.appendChild(predesignImg);
      return;
    }
    // Custom design: ensure the uniform border frame is visible.
    if (finalBorderFrame) finalBorderFrame.style.display = '';

    selectedData.designLayers.forEach(layerData => {
  const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

      if (layerData.type === 'image') {
        const imageEl = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        imageEl.setAttribute('x', -layerData.w / 2);
        imageEl.setAttribute('y', -layerData.h / 2);
        imageEl.setAttribute('width', layerData.w);
        imageEl.setAttribute('height', layerData.h);
        imageEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', layerData.dataURL);
        imageEl.setAttribute('preserveAspectRatio', 'none');
        g.appendChild(imageEl);
      } else {
        const textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textEl.setAttribute('text-anchor', 'middle');
        textEl.setAttribute('dominant-baseline', 'middle');
        textEl.setAttribute('font-family', layerData.font);
        textEl.setAttribute('font-size', layerData.size);
        textEl.setAttribute('fill', layerData.color);
        textEl.setAttribute('font-weight', layerData.weight);
        textEl.textContent = layerData.text;
        g.appendChild(textEl);
      }

      const flipX = layerData.flipX || 1;
      const flipY = layerData.flipY || 1;
      const transform = `translate(${layerData.tx}, ${layerData.ty}) rotate(${layerData.rot}) scale(${layerData.scale * flipX}, ${layerData.scale * flipY})`;
      g.setAttribute('transform', transform);
      finalLayers.appendChild(g);
    });
  }

  function updateSummary() {
    let total = pricing.base;
    let originalTotal = pricing.base;
    
    const variantIdsToAdd = [];
    
    variantIdsToAdd.push(VARIANT_IDS.gumshield[selectedData.impressionMethod]);

    // ← ADD THESE 5 LINES HERE
    const hasGymDiscount = selectedData.impressionMethod === 'gym-kit';
    if (hasGymDiscount) {
      total = total * GYM_KIT_DISCOUNT_RATE;
      originalTotal = pricing.base;
    }

    const colourElem = document.getElementById('piranha-summary-colour');
    if (selectedData.baseColour && colourElem) {
      const valueElem = colourElem.querySelector('.piranha-summary-value');
      if (valueElem) {
        let displayName = selectedData.baseColour.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        valueElem.textContent = displayName;
      }
    }

    const designElem = document.getElementById('piranha-summary-design');
    if (designElem) {
      if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesign) {
        designElem.style.display = 'flex';
        const labelElem = designElem.querySelector('.piranha-summary-label');
        const valueElem = designElem.querySelector('.piranha-summary-value');
        if (labelElem) labelElem.textContent = 'Design';
        if (valueElem) {
          let designName = selectedData.selectedPredesign.charAt(0).toUpperCase() + selectedData.selectedPredesign.slice(1);
          valueElem.textContent = 'Pre-designed ' + designName;
        }
      } else if (selectedData.designChoice === 'custom') {
        designElem.style.display = 'flex';
        const labelElem = designElem.querySelector('.piranha-summary-label');
        const valueElem = designElem.querySelector('.piranha-summary-value');
        if (labelElem) labelElem.textContent = 'Custom Design';
        if (valueElem) valueElem.textContent = 'Included';
      } else {
        designElem.style.display = 'none';
      }
    }

    if (selectedData.designChoice === 'predesign' && colourElem) {
      colourElem.style.display = 'none';
    } else if (colourElem) {
      colourElem.style.display = 'flex';
    }

    const storageCaseElem = document.getElementById('piranha-summary-storage-case');
    if (storageCaseElem) {
      if (selectedData.storageCase) {
        storageCaseElem.style.display = 'flex';
        const valueElem = document.getElementById('piranha-storage-case-value');
        if (valueElem) {
          let caseName = selectedData.storageCase.charAt(0).toUpperCase() + selectedData.storageCase.slice(1);
          valueElem.textContent = caseName;
        }
      } else {
        storageCaseElem.style.display = 'none';
      }
    }

    const expressElem = document.getElementById('piranha-summary-express');
if (expressElem) {
  // Express is always included free now
  expressElem.style.display = 'flex';
  // Don't add to total or variants since it's free
  // total += pricing.expressDelivery;
  // variantIdsToAdd.push(VARIANT_IDS.addons.express);
}

   const nameTagElem = document.getElementById('piranha-summary-nametag');
    let nameTagQuantity = selectedData.insideNameTag ? 1 : 0;
    let displayQuantity = nameTagQuantity;
    if (selectedData.insideNameTag && selectedData.backupQuantity > 0) {
      displayQuantity += selectedData.backupQuantity;
    }
    
    if (nameTagElem) {
      if (selectedData.insideNameTag) { 
        nameTagElem.style.display = 'flex'; 
        const valueElem = nameTagElem.querySelector('.piranha-summary-value');
        const labelElem = nameTagElem.querySelector('.piranha-summary-label');

        if (valueElem && selectedData.nameText) {
          let tagTotal = pricing.nameTag;
          if (hasGymDiscount) tagTotal = tagTotal * GYM_KIT_DISCOUNT_RATE;
          total += tagTotal;

          if (labelElem) {
            const existingName = labelElem.querySelector('.added-name-text');
            if (existingName) existingName.remove();

            const nameSpan = document.createElement('span');
            nameSpan.className = 'added-name-text';
            nameSpan.style.color = 'black';
            nameSpan.style.fontWeight = '600';
            nameSpan.style.marginLeft = '6px';
            nameSpan.textContent = `"${selectedData.nameText}"`;
            labelElem.appendChild(nameSpan);
          }


          valueElem.innerHTML = `
            <span style="color: #13668D; font-weight: 700;">£${tagTotal.toFixed(2)}</span>
          `;
        } else if (valueElem) {
          let tagTotal = pricing.nameTag;
          if (hasGymDiscount) tagTotal = tagTotal * GYM_KIT_DISCOUNT_RATE;
          total += tagTotal;


          valueElem.innerHTML = `
            <span style="color: #13668D; font-weight: 700;">£${tagTotal.toFixed(2)}</span>
          `;
        }
      } else {
        nameTagElem.style.display = 'none';
        const labelElem = nameTagElem.querySelector('.piranha-summary-label');
        if (labelElem) {
          const existingName = labelElem.querySelector('.added-name-text');
          if (existingName) existingName.remove();
        }
      }
    }

    const backupElem = document.getElementById('piranha-summary-backup');
    if (backupElem) {
      if (selectedData.backupQuantity > 0) {
        backupElem.style.display = 'flex';
        
        // Calculate backup total with discount
        let backupTotal = pricing.backupPrice * selectedData.backupQuantity;
        if (hasGymDiscount) backupTotal = backupTotal * GYM_KIT_DISCOUNT_RATE;
        
        // Update display elements
        const qtyElem = document.getElementById('piranha-summary-backup-qty');
        const valueElem = backupElem.querySelector('.piranha-summary-value');
        
        if (qtyElem) qtyElem.textContent = selectedData.backupQuantity;
        

        if (valueElem) {
          valueElem.innerHTML = `<span id="piranha-summary-backup-price">${backupTotal.toFixed(2)}</span> Included`;
        }
        
        // Add to total
        total += backupTotal;
        
        // Track original for comparison
        if (!hasGymDiscount) {
          originalTotal = pricing.base * selectedData.backupQuantity;
        }
      } else {
        backupElem.style.display = 'none';
      }
    }

    const productionTimeValue = document.getElementById('piranha-production-time-value');
    if (productionTimeValue) {
      if (selectedData.expressDelivery) {
        productionTimeValue.innerHTML = '<strong style="color: #13668D;">2 working days</strong> <span class="production-time-popup-link"><svg width="16" height="16" viewBox="0 0 384 384" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer; vertical-align: middle; display: inline-block;"><path d="M204.07,0l19.65,2.47c82.16,13.46,147.87,81.06,158.67,163.76.59,4.51.46,9.45,1.61,13.77v24c-1.16,4.32-1.01,9.26-1.61,13.77-10.97,82.81-76.38,150.2-158.67,163.76l-19.65,2.47h-23.99c-4.32-1.16-9.26-1.01-13.76-1.61C81.48,371.14,12.85,302.73,1.75,217.77c-.59-4.51-.46-9.45-1.61-13.77.34-7.93-.46-16.09,0-24C5.72,84.68,84.79,5.58,180.08,0h23.99ZM182.17,30.22C56.52,37.78-13.5,181.74,59.51,285.24c67.72,95.99,212.6,90.34,272.14-10.98,65.79-111.97-20.45-251.8-149.48-244.03Z"/><path d="M190.41,160.68c8.65-.95,15.94,6.02,16.69,14.42,2.83,31.67-2.13,67.6-.1,99.71-3.43,17.27-28.37,16.33-29.95-1.4-2.82-31.68,2.12-67.59.1-99.71,1.16-6.41,6.67-12.29,13.27-13.02Z"/><path d="M206.05,136.98c-18.86,17.96-47.48-10.72-27.88-29.77,18.71-18.18,47.47,11.11,27.88,29.77Z"/></svg></span>';
      } else {
        productionTimeValue.innerHTML = '<span>7 working days</span> <span class="open-production-time-modal-seven"><svg width="16" height="16" viewBox="0 0 384 384" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer; vertical-align: middle; display: inline-block;margin-left: 4px;"><path d="M204.07,0l19.65,2.47c82.16,13.46,147.87,81.06,158.67,163.76.59,4.51.46,9.45,1.61,13.77v24c-1.16,4.32-1.01,9.26-1.61,13.77-10.97,82.81-76.38,150.2-158.67,163.76l-19.65,2.47h-23.99c-4.32-1.16-9.26-1.01-13.76-1.61C81.48,371.14,12.85,302.73,1.75,217.77c-.59-4.51-.46-9.45-1.61-13.77.34-7.93-.46-16.09,0-24C5.72,84.68,84.79,5.58,180.08,0h23.99ZM182.17,30.22C56.52,37.78-13.5,181.74,59.51,285.24c67.72,95.99,212.6,90.34,272.14-10.98,65.79-111.97-20.45-251.8-149.48-244.03Z"/><path d="M190.41,160.68c8.65-.95,15.94,6.02,16.69,14.42,2.83,31.67-2.13,67.6-.1,99.71-3.43,17.27-28.37,16.33-29.95-1.4-2.82-31.68,2.12-67.59.1-99.71,1.16-6.41,6.67-12.29,13.27-13.02Z"/><path d="M206.05,136.98c-18.86,17.96-47.48-10.72-27.88-29.77,18.71-18.18,47.47,11.11,27.88,29.77Z"/></svg></span>';
      }
    }

      const summaryTotalPrice = document.getElementById('piranha-summary-total-price');
    if (summaryTotalPrice) {
      if (hasGymDiscount) {
        const originalPrice = (originalTotal + (selectedData.insideNameTag ? pricing.nameTag : 0) + (selectedData.backupQuantity * pricing.backupPrice)).toFixed(2);
        summaryTotalPrice.innerHTML = `
          <span style="text-decoration: line-through; opacity: 0.5; font-size: 0.9em; margin-right: 8px;">£${originalPrice}</span>
          £${total.toFixed(2)}
          <span style="color: #13668D; font-size: 0.85em; font-weight: 600; margin-left: 8px;">(5% gym discount)</span>
        `;
      } else {
        summaryTotalPrice.textContent = '£' + total.toFixed(2);
      }
    }

    const installmentEl = document.getElementById('piranha-summary-total-installment');
    if (installmentEl) {
      const installmentValue = (total / 3).toFixed(2);
      installmentEl.innerHTML = `or 3 interest-free payments of <span class="price">£${installmentValue}</span> with <span class="klarna">Klarna</span>`;
    }

    updateFooterPricing(total, originalTotal);

    const deliveryTime = selectedData.expressDelivery
      ? '2 working days'
      : '7 working days';
    const deliveryTimeElem = document.getElementById('piranha-summary-delivery-time');
    if (deliveryTimeElem) deliveryTimeElem.textContent = deliveryTime;

    const methodMap = {
      'impression-kit': 'Free Impression Kit',
      'dental-scan': 'Digital Dental Scan',
      'own-models': 'Your Own Models',
        'gym-kit': 'Gym Impression Kit'  // ← ADD THIS LINE
    };
    const impressionMethodElem = document.getElementById('piranha-summary-impression-method');
    if (impressionMethodElem) impressionMethodElem.textContent = methodMap[selectedData.impressionMethod] || 'Not selected';

    const freeKit = document.getElementById('piranha-free-kit');
    const freeShipping = document.getElementById('piranha-free-shipping');
    const freeLabel = document.getElementById('piranha-free-label');
    const freeScanShipping = document.getElementById('piranha-free-scan-shipping');
    const warranty = document.getElementById('piranha-warranty');
    const storageCase = document.getElementById('piranha-storage-case');

    if (freeKit) freeKit.style.display = 'none';
    if (freeShipping) freeShipping.style.display = 'none';
    if (freeLabel) freeLabel.style.display = 'none';
    if (freeScanShipping) freeScanShipping.style.display = 'none';
    
    if (selectedData.impressionMethod === 'impression-kit') {
      if (freeKit) freeKit.style.display = 'flex';
      if (freeShipping) freeShipping.style.display = 'flex';
    } else if (selectedData.impressionMethod === 'own-models') {
      if (freeLabel) freeLabel.style.display = 'flex';
    } else if (selectedData.impressionMethod === 'dental-scan') {
      if (freeScanShipping) freeScanShipping.style.display = 'flex';
    } else if (selectedData.impressionMethod === 'gym-kit') {  // ← ADD THESE 3 LINES
      if (freeLabel) freeLabel.style.display = 'flex';
    }
    
    if (warranty) warranty.style.display = 'flex';
    if (storageCase) storageCase.style.display = 'flex';

    const standardDeliveryText = document.getElementById('piranha-standard-delivery-text');
    if (standardDeliveryText && selectedData.impressionMethod) {
      standardDeliveryText.textContent = selectedData.deliveryDays + ' working days';
    }
    
    updateDeliveryDateDisplay();
    updateCanvasTextWarning();

    selectedData.variantIds = variantIdsToAdd;
  }

  function updateDeliveryDateDisplay() {
    const deliveryDateText = getFormattedDeliveryDate();
    const kitDateSpan = document.getElementById('piranha-kit-date');
    if (kitDateSpan) {
      kitDateSpan.textContent = deliveryDateText;
    }

    const summaryKitElement = document.getElementById('piranha-free-kit');
    if (summaryKitElement && selectedData.impressionMethod === 'impression-kit') {
      const kitSpan = summaryKitElement.querySelector('span');
      if (kitSpan) {
        kitSpan.innerHTML = `Free Impression Kit`;
      }
    }
  }

  function updateFooterPricing(total, originalTotal) {
    // Implementation for footer pricing if needed
  }

  // Order file upload — uses the upload-piranha-order edge function on the
  // Meridian Supabase project (npuvhxakffxqoszytkxw). The function stores
  // the object in the public `piranha-orders` bucket and returns a
  // permanent public URL which we attach to the Shopify order line item
  // property `_Design Files`. Replaces the previous Cloudinary unsigned-
  // preset upload.
  const PIRANHA_UPLOAD_URL = 'https://npuvhxakffxqoszytkxw.supabase.co/functions/v1/upload-piranha-order';

  async function uploadOrderFiles(fileBlob, filename) {
    const formData = new FormData();
    formData.append('file', fileBlob, filename);

    const response = await fetch(PIRANHA_UPLOAD_URL, {
      method: 'POST',
      body: formData
    });

    let data;
    try { data = await response.json(); }
    catch (_) { data = null; }

    if (!response.ok) {
      const detail = (data && (data.error || data.detail)) || `HTTP ${response.status}`;
      throw new Error('Upload failed: ' + detail);
    }
    if (!data || !data.public_url) {
      throw new Error('Upload failed: missing public_url in response');
    }
    return data.public_url;
  }

// Convert any URL (remote or data:) to a fully self-contained data URL.
// Used to inline remote images into the SVG before rasterise, which would
// otherwise taint the canvas and make toDataURL() throw SecurityError.
async function loadImageAsDataURL(url) {
  if (!url) throw new Error('loadImageAsDataURL: empty url');
  if (url.startsWith('data:')) return url;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = url;
  await img.decode();
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  canvas.getContext('2d').drawImage(img, 0, 0);
  return canvas.toDataURL('image/png');
}

// Returns a PNG Blob of the customer's design. For custom designs this is
// the rasterised final-preview SVG; for predesigns it's the chosen library
// image. Used both as the customer-facing preview image attached to the
// Shopify order and as the source for the layout-plan PDF screenshot.
// ── Font embedding for rasterised previews ───────────────────────────────
// SVG → Image rasterisation runs in a sandboxed context that cannot see
// the page's CSS @font-face rules and cannot make network requests for
// font files. To render the customer's chosen display font in the baked
// PNG, we walk document.styleSheets, find every @font-face rule used by
// the SVG we're about to rasterise, fetch the font file, base64-encode
// it, and inject a `<defs><style>@font-face { ... src: url(data:...); }
// </style></defs>` block into the SVG before rasterising.
//
// Results are cached in a module-scoped Map so repeat rasterises (the
// design preview + the text preview baked alongside it) don't refetch.
// Cache key is the lowercased family name.
const _piranhaFontCache = new Map(); // family-lower → { dataURL, format, weight, style, family }

function _piranhaFindFontFaceRules() {
  const out = [];
  for (const sheet of document.styleSheets) {
    let rules;
    try { rules = sheet.cssRules; } catch (_) { continue; } // cross-origin sheet, skip
    if (!rules) continue;
    for (const rule of rules) {
      if (!rule || !rule.cssText || !/^@font-face/i.test(rule.cssText)) continue;
      const style = rule.style;
      if (!style) continue;
      const family = (style.getPropertyValue('font-family') || '').replace(/['"]/g, '').trim();
      const srcValue = style.getPropertyValue('src') || '';
      const weight = (style.getPropertyValue('font-weight') || '400').trim();
      const fontStyle = (style.getPropertyValue('font-style') || 'normal').trim();
      const urlMatch = srcValue.match(/url\(\s*(['"]?)([^'")]+)\1\s*\)/);
      if (!family || !urlMatch) continue;
      const url = urlMatch[2];
      const fmtMatch = srcValue.match(/format\(\s*(['"]?)([^'")]+)\1\s*\)/);
      const format = fmtMatch ? fmtMatch[2]
        : (/\.otf(\?|$)/i.test(url) ? 'opentype' : 'truetype');
      out.push({ family, weight, style: fontStyle, url, format });
    }
  }
  return out;
}

async function _piranhaFetchFontAsDataURL(url) {
  const absUrl = new URL(url, document.baseURI).href;
  const resp = await fetch(absUrl, { credentials: 'omit' });
  if (!resp.ok) throw new Error(`Font fetch ${resp.status}: ${absUrl}`);
  const blob = await resp.blob();
  return await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(r.error || new Error('FileReader error'));
    r.readAsDataURL(blob);
  });
}

// Builds an @font-face CSS block restricted to the requested family names.
// Returns '' on any failure so callers can degrade gracefully.
async function buildInlineFontFaceCSS(requestedFamilies) {
  if (!requestedFamilies || requestedFamilies.length === 0) return '';
  const wantedSet = new Set(
    requestedFamilies
      .map(s => String(s || '').replace(/['"]/g, '').trim().toLowerCase())
      .filter(Boolean)
  );
  if (wantedSet.size === 0) return '';

  const rules = _piranhaFindFontFaceRules();
  const blocks = [];

  for (const r of rules) {
    if (!wantedSet.has(r.family.toLowerCase())) continue;
    const key = r.family.toLowerCase();
    if (!_piranhaFontCache.has(key)) {
      try {
        const dataURL = await _piranhaFetchFontAsDataURL(r.url);
        _piranhaFontCache.set(key, {
          family: r.family, dataURL, format: r.format,
          weight: r.weight, style: r.style, rawUrl: r.url,
        });
      } catch (e) {
        console.warn('[piranha] could not inline font', r.family, e);
        continue;
      }
    }
    const cached = _piranhaFontCache.get(key);
    blocks.push(
      `@font-face{font-family:'${cached.family}';font-style:${cached.style};font-weight:${cached.weight};src:url('${cached.dataURL}') format('${cached.format}');}`
    );
  }
  return blocks.join('\n');
}

function extractFontFamiliesFromSVG(svgEl) {
  const families = new Set();
  for (const t of svgEl.querySelectorAll('text')) {
    const f = t.getAttribute('font-family');
    if (f) families.add(f.replace(/['"]/g, '').trim());
  }
  return Array.from(families);
}

// Inject @font-face CSS into the SVG clone's <defs> so the rasterised
// image can resolve the customer's display fonts.
async function injectInlinedFontsIntoSVG(svgClone) {
  const families = extractFontFamiliesFromSVG(svgClone);
  if (families.length === 0) return;
  // Ensure live document has loaded the fonts (no-op when already loaded).
  for (const fam of families) {
    try { await document.fonts.load(`16px "${fam}"`); } catch (_) {}
  }
  const fontCSS = await buildInlineFontFaceCSS(families);
  if (!fontCSS) return;
  let defs = svgClone.querySelector('defs');
  if (!defs) {
    defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    svgClone.insertBefore(defs, svgClone.firstChild);
  }
  const styleEl = document.createElementNS('http://www.w3.org/2000/svg', 'style');
  styleEl.setAttribute('type', 'text/css');
  styleEl.textContent = fontCSS;
  defs.appendChild(styleEl);
}

// Attempts to register a custom font with jsPDF so the standalone
// text-element PDF renders in the customer's actual typeface. Returns
// the family name on success, null on failure (caller falls back to
// helvetica/times/courier mapping). OTF files are skipped because
// jsPDF's TTF parser doesn't handle every OTF table cleanly.
async function tryRegisterCustomPdfFont(doc, family) {
  if (!doc || !family) return null;
  const key = String(family).toLowerCase();
  let cached = _piranhaFontCache.get(key);
  if (!cached) {
    const rule = _piranhaFindFontFaceRules().find(r => r.family.toLowerCase() === key);
    if (!rule) return null;
    try {
      const dataURL = await _piranhaFetchFontAsDataURL(rule.url);
      cached = {
        family: rule.family, dataURL, format: rule.format,
        weight: rule.weight, style: rule.style, rawUrl: rule.url,
      };
      _piranhaFontCache.set(key, cached);
    } catch (_) { return null; }
  }
  if ((cached.format || '').toLowerCase() === 'opentype') return null;
  const base64 = (cached.dataURL || '').split(',')[1];
  if (!base64) return null;
  const safe = cached.family.replace(/[^a-zA-Z0-9_-]/g, '_');
  const filename = `${safe}.ttf`;
  try {
    doc.addFileToVFS(filename, base64);
    doc.addFont(filename, cached.family, 'normal');
    return cached.family;
  } catch (e) {
    console.warn('[piranha] jsPDF addFont failed', cached.family, e);
    return null;
  }
}

// XML-escape helpers used by the SVG synthesis below. The customer's text
// can contain &, <, >, ", ' — without escaping these break the serialised
// SVG and the image either renders garbled or fails to decode at all.
function xmlText(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
function xmlAttr(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

// Bakes a single text layer (its text, font, weight, size, colour) into a
// standalone PNG so Checkpoint can show the customer's text in the exact
// font they chose, without needing to load the customiser's font stack.
async function generateTextPreviewBlob(layer) {
  try {
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
  } catch (_) { /* font wait optional */ }

  const text = layer && layer.text ? String(layer.text) : '';
  const font = (layer && layer.font) || 'Arial';
  const weight = (layer && layer.weight) || 'normal';
  const fill = (layer && layer.color) || '#000000';
  const fontSize = parseFloat(layer && layer.size) || 64;
  const charW = fontSize * 0.62;
  const width  = Math.max(320, Math.ceil(text.length * charW + 96));
  const height = Math.ceil(fontSize * 1.8);

  // Inline the @font-face for this layer's family so the rasterised image
  // resolves it. Falls back to system serif/sans on any failure.
  try { await document.fonts.load(`${fontSize}px "${font}"`); } catch (_) {}
  const fontCSS = await buildInlineFontFaceCSS([font]);
  const fontStyleBlock = fontCSS ? `<defs><style type="text/css">${fontCSS}</style></defs>` : '';

  // Transparent background — Checkpoint picks the contrast colour at
  // render time based on the customer's chosen text colour. Baking
  // white in here meant white-on-white text was invisible the moment
  // the lab opened the order.
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">${fontStyleBlock}
  <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-family="${xmlAttr(font)}" font-size="${fontSize}" font-weight="${xmlAttr(weight)}" fill="${xmlAttr(fill)}">${xmlText(text)}</text>
</svg>`;

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = 'data:image/svg+xml;base64,' + _piranhaUtf8ToBase64(svg);
  await img.decode();

  const canvas = document.createElement('canvas');
  canvas.width = width * 2;   // retina
  canvas.height = height * 2;
  const ctx = canvas.getContext('2d');
  // Do NOT fill — keep alpha channel intact so the saved PNG is
  // transparent everywhere except where the glyphs sit.
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  return await new Promise((resolve, reject) =>
    canvas.toBlob(b => b ? resolve(b) : reject(new Error('toBlob failed')), 'image/png'));
}

async function generateDesignPreviewBlob() {
  try {
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
  } catch (_) { /* font wait optional */ }

  // Predesign path: rasterise the chosen library image directly. The image
  // has correct natural dimensions, so we copy them verbatim.
  if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesignImage) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = selectedData.selectedPredesignImage;
    await img.decode();
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    canvas.getContext('2d').drawImage(img, 0, 0);
    return await new Promise((resolve, reject) =>
      canvas.toBlob(b => b ? resolve(b) : reject(new Error('toBlob failed')), 'image/png'));
  }

  // Custom path: clone the live preview SVG, inline any remote image hrefs
  // (otherwise cdn.shopify.com URLs taint the canvas and toBlob fails),
  // then rasterise at the SVG's own viewBox aspect.
  //
  // Critical: honour the viewBox attribute on the source SVG, NOT a
  // getBBox()-computed rectangle. The final-preview SVG declares
  // viewBox="0 250 2214 800" — that's the gumshield framing the
  // customer sees in the order-summary modal. Inside that viewBox,
  // however, sits a base-colour <rect x=0 y=0 width=2214 height=1278>
  // that extends well beyond the visible frame (it's there so any
  // arch position renders into a full-canvas fill, then gets clipped).
  // getBBox returns the geometric union of every child element and
  // ignores clip-path / viewBox, so it captures the rect's full 1278
  // height and produces an aspect of 1.73 instead of the true 2.77.
  // The rasterised PNG then ends up taller than the customer's view,
  // and the lab sees a vertically-stretched silhouette.
  //
  // Solution: read viewBox from the source, size the canvas to its
  // aspect, set explicit width/height on the clone so the Image
  // element's naturalWidth/Height is deterministic, and draw at full
  // canvas dims. No DOM mount, no getBBox.
  const svgElement = document.querySelector('.piranha-final-preview-svg');
  if (!svgElement) throw new Error('Preview not available');

  // Parse the viewBox attribute — falls back to the design canvas
  // viewBox if the attribute is missing or malformed.
  const viewBoxStr = svgElement.getAttribute('viewBox') || '0 0 2214 1278';
  const vbParts = viewBoxStr.trim().split(/[\s,]+/).map(parseFloat);
  const vbW = vbParts.length === 4 && vbParts[2] > 0 ? vbParts[2] : 2214;
  const vbH = vbParts.length === 4 && vbParts[3] > 0 ? vbParts[3] : 1278;
  const aspect = vbW / vbH;

  const svgClone = svgElement.cloneNode(true);
  const imageEls = svgClone.querySelectorAll('image');
  for (const imgEl of imageEls) {
    const href =
      imgEl.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
      imgEl.getAttribute('href');
    if (href && !href.startsWith('data:')) {
      try {
        const dataURL = await loadImageAsDataURL(href);
        imgEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', dataURL);
        imgEl.setAttribute('href', dataURL);
      } catch (e) {
        console.warn('Could not inline SVG image:', href, e);
      }
    }
  }

  // Inline @font-face for any display fonts used by text layers so the
  // rasterised image picks them up. Skipped silently if any step fails
  // — text falls back to system font which matches previous behaviour.
  await injectInlinedFontsIntoSVG(svgClone);

  const targetWidth = 2400;
  const targetHeight = Math.max(1, Math.round(targetWidth / aspect));
  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext('2d');

  // Set explicit width/height on the clone so the Image element decodes
  // to a known natural size, then drawImage at the same dims renders
  // edge-to-edge with no implicit scaling.
  svgClone.setAttribute('width',  String(targetWidth));
  svgClone.setAttribute('height', String(targetHeight));
  // viewBox stays untouched — the customer's framing is the source of
  // truth, the same one the order-summary modal uses to render live.

  const svgData = new XMLSerializer().serializeToString(svgClone);
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = 'data:image/svg+xml;base64,' + _piranhaUtf8ToBase64(svgData);
  await img.decode();

  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  return await new Promise((resolve, reject) =>
    canvas.toBlob(b => b ? resolve(b) : reject(new Error('toBlob failed')), 'image/png'));
}

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

// Builds the layout-plan PDF. Takes the design preview PNG (from
// generateDesignPreviewBlob) so we don't re-rasterise. Bottom-anchored
// footer + capped preview area guarantee the configuration rows never
// collide with the footer band — previously the hardcoded Y=190 footer
// got overwritten by configuration text on tall designs.
async function generatePreviewPDF(previewBlob) {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  // ── Page geometry (landscape A4) ───────────────────────────────────
  const PAGE_W = 297, PAGE_H = 210;
  const MARGIN_X = 18;
  const HEADER_Y = 20;
  const FOOTER_BAND = 16;            // height reserved at the bottom
  const FOOTER_TOP = PAGE_H - FOOTER_BAND;
  const PREVIEW_Y_TOP = HEADER_Y + 10;

  // Dynamic reserve so the preview shrinks to make room for whatever
  // configuration + text-element content the order needs. The lab MUST
  // see the text layers so we never let the preview crowd them out.
  const _textLayers = (selectedData?.designLayers || []).filter(l => l.type === 'text');
  const _textBlockH = _textLayers.length > 0 ? (14 + Math.min(_textLayers.length, 4) * 14) : 0;
  const CONFIG_RESERVE = 56 + _textBlockH;
  const PREVIEW_AVAILABLE_H = FOOTER_TOP - PREVIEW_Y_TOP - CONFIG_RESERVE - 4;

  // ── Header ─────────────────────────────────────────────────────────
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.setTextColor(20, 20, 20);
  doc.text('Gumshield Design Layout Plan', MARGIN_X, HEADER_Y);
  doc.setLineWidth(0.3);
  doc.setDrawColor(210, 210, 210);
  doc.line(MARGIN_X, HEADER_Y + 3, PAGE_W - MARGIN_X, HEADER_Y + 3);

  // ── Preview image (capped so config + footer always fit) ───────────
  let previewBottom = PREVIEW_Y_TOP;
  if (previewBlob) {
    try {
      const dataURL = await blobToDataURL(previewBlob);
      const probe = new Image();
      probe.src = dataURL;
      await probe.decode();
      const aspect = probe.naturalWidth / probe.naturalHeight;
      const maxW = PAGE_W - 2 * MARGIN_X;
      let targetW = maxW;
      let targetH = targetW / aspect;
      if (targetH > PREVIEW_AVAILABLE_H) {
        targetH = PREVIEW_AVAILABLE_H;
        targetW = targetH * aspect;
      }
      const xPos = (PAGE_W - targetW) / 2;
      doc.addImage(dataURL, 'PNG', xPos, PREVIEW_Y_TOP, targetW, targetH);
      previewBottom = PREVIEW_Y_TOP + targetH;
    } catch (e) {
      console.warn('Embedding preview into PDF failed:', e);
    }
  }

  // ── Configuration block ────────────────────────────────────────────
  const CONFIG_Y = Math.min(previewBottom + 14, FOOTER_TOP - CONFIG_RESERVE);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(95, 95, 95);
  doc.text('CONFIGURATION', MARGIN_X, CONFIG_Y);
  doc.setLineWidth(0.2);
  doc.setDrawColor(225, 225, 225);
  doc.line(MARGIN_X, CONFIG_Y + 2, PAGE_W - MARGIN_X, CONFIG_Y + 2);

  const rows = [];
  if (selectedData) {
    if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesign) {
      rows.push(['Prebuilt Design', selectedData.selectedPredesign]);
    } else if (selectedData.baseColour) {
      rows.push(['Base Colour', selectedData.baseColour]);
    }
    if (selectedData.storageCase) {
      const c = selectedData.storageCase;
      rows.push(['Storage Case', c.charAt(0).toUpperCase() + c.slice(1)]);
    }
    if (selectedData.expressDelivery) rows.push(['Express Production', 'Yes']);
    if (selectedData.insideNameTag)   rows.push(['Inside Name Tag', selectedData.nameText || 'N/A']);
    if (selectedData.backupQuantity > 0) rows.push(['Backup Gumshields', String(selectedData.backupQuantity)]);
  }

  const ROW_H = 6;
  let y = CONFIG_Y + 8;
  for (const [label, value] of rows) {
    if (y + ROW_H > FOOTER_TOP - 4) break;   // never cross the footer band
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(120, 120, 120);
    doc.text(label, MARGIN_X, y);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(25, 25, 25);
    doc.text(String(value), MARGIN_X + 54, y);
    y += ROW_H;
  }

  // ── Text elements block ───────────────────────────────────────────
  // Every text layer with its text, font, size, weight, and colour so
  // the lab can reproduce the design without opening any other file.
  if (_textLayers.length > 0) {
    y += 4;
    if (y + 12 < FOOTER_TOP - 4) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(95, 95, 95);
      doc.text('TEXT ELEMENTS', MARGIN_X, y);
      doc.setLineWidth(0.2);
      doc.setDrawColor(225, 225, 225);
      doc.line(MARGIN_X, y + 2, PAGE_W - MARGIN_X, y + 2);
      y += 8;

      const MAX_LAYERS_PRINTED = 4;
      const printable = _textLayers.slice(0, MAX_LAYERS_PRINTED);
      printable.forEach((layer, i) => {
        if (y + 14 > FOOTER_TOP - 4) return;

        // Primary line — index + the customer's text.
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(25, 25, 25);
        const text = String(layer.text || '').trim() || '(empty)';
        doc.text(`${i + 1}. "${text}"`, MARGIN_X, y);
        y += 6;

        // Detail line — font, size, weight, colour all in one row.
        const weightDisplay = String(layer.weight || '').toLowerCase() === 'bold' ? 'Bold' : 'Regular';
        const detail = [
          `Font: ${layer.font || 'Arial'}`,
          `Size: ${layer.size != null ? layer.size : '—'}`,
          `Weight: ${weightDisplay}`,
          `Colour: ${layer.color || '—'}`,
        ].join('  ·  ');
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(120, 120, 120);
        doc.text(detail, MARGIN_X + 6, y);
        y += 8;
      });

      if (_textLayers.length > MAX_LAYERS_PRINTED && y + 6 < FOOTER_TOP - 4) {
        doc.setFont('helvetica', 'italic');
        doc.setFontSize(9);
        doc.setTextColor(150, 150, 150);
        doc.text(`+ ${_textLayers.length - MAX_LAYERS_PRINTED} more text element${_textLayers.length - MAX_LAYERS_PRINTED === 1 ? '' : 's'} (see order details in Checkpoint)`, MARGIN_X, y);
      }
    }
  }

  // ── Footer band (bottom anchored) ──────────────────────────────────
  doc.setDrawColor(225, 225, 225);
  doc.setLineWidth(0.3);
  doc.line(MARGIN_X, FOOTER_TOP, PAGE_W - MARGIN_X, FOOTER_TOP);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(140, 140, 140);
  doc.text('Venneir Limited · Custom Dental Appliances', MARGIN_X, FOOTER_TOP + 6);
  const generated = `Generated ${new Date().toLocaleString('en-GB')}`;
  doc.text(generated, PAGE_W - MARGIN_X, FOOTER_TOP + 6, { align: 'right' });

  return doc.output('blob');
}

  // Generate text element PDF
  async function generateTextPDF(layer, index) {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });

    doc.setFontSize(18);
    doc.text(`Text Element #${index}`, 15, 15);

    doc.setFontSize(16);
    doc.text('Text Display:', 15, 35);

    doc.setFillColor(234, 234, 234);
    doc.rect(15, 45, 180, 80, 'F');

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.rect(15, 45, 180, 80);

    const textContent = layer.text || 'Sample Text';

    // Try to register the customer's actual font with jsPDF (TTF only).
    // Falls back to the helvetica/times/courier mapping if registration
    // fails — same behaviour as before for OTF families and unknowns.
    const registeredFamily = await tryRegisterCustomPdfFont(doc, layer.font);

    const fallbackMap = {
      'Arial': 'helvetica',
      'Times New Roman': 'times',
      'Courier New': 'courier',
      'Courier': 'courier',
      'Georgia': 'times',
    };
    const pdfFont = registeredFamily || fallbackMap[layer.font] || 'helvetica';
    const pdfWeight = (layer.weight === 'bold' || layer.font === 'Impact') ? 'bold' : 'normal';

    try { doc.setFont(pdfFont, pdfWeight); }
    catch (_) { doc.setFont('helvetica', pdfWeight); }
    doc.setTextColor(0, 0, 0);
    
    const pdfSize = layer.size ? Math.min(layer.size * 0.75, 48) : 24;
    doc.setFontSize(pdfSize);
    
    const textWidth = doc.getTextWidth(textContent);
    const boxCenterX = 15 + (180 / 2);
    const boxCenterY = 45 + (80 / 2);
    
    if (layer.rot && layer.rot !== 0) {
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 1 }));
      const angleRad = (layer.rot * Math.PI) / 180;
      doc.text(textContent, boxCenterX, boxCenterY, { 
        align: 'center',
        baseline: 'middle',
        angle: layer.rot
      });
      doc.restoreGraphicsState();
    } else {
      doc.text(textContent, boxCenterX, boxCenterY, { 
        align: 'center',
        baseline: 'middle'
      });
    }
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    
    doc.setFontSize(14);
    doc.text('Configuration:', 15, 140);
    
    doc.setFontSize(11);
    let yPos = 150;
    doc.text(`Font: ${layer.font || 'Arial'}`, 20, yPos);
    yPos += 8;
    doc.text(`Font Weight: ${layer.weight || 'normal'}`, 20, yPos);
    yPos += 8;
    doc.text(`Size: ${layer.size || 32}px`, 20, yPos);
    yPos += 8;
    doc.text(`Original Color: ${layer.color || '#000000'}`, 20, yPos);
    yPos += 8;
    doc.text(`Rotation: ${Math.round(layer.rot || 0)}°`, 20, yPos);
    yPos += 8;
    doc.text(`Scale: ${Math.round((layer.scale || 1) * 100)}%`, 20, yPos);
    yPos += 8;
    doc.text(`Position: X=${Math.round(layer.tx || 0)}, Y=${Math.round(layer.ty || 0)}`, 20, yPos);
    yPos += 8;
    
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text('Note: Text is displayed in black on gray background for preview clarity.', 20, yPos);
    doc.text('The actual product will use the original color specified above.', 20, yPos + 5);
    
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Venneir Limited - Custom Dental Appliances', 15, 285);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 15, 290);
    
    return doc.output('blob');
  }

  // Generate inside name tag PDF
  function generateInsideTagPDF() {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
    
    doc.setFontSize(18);
    doc.text('Inside Name Tag', 15, 15);
    
    doc.setFontSize(14);
    doc.text('Visual Display:', 15, 35);
    
    const baseColorHex = selectedData.baseColourHex || '#FF0000';
    const bgR = parseInt(baseColorHex.slice(1, 3), 16);
    const bgG = parseInt(baseColorHex.slice(3, 5), 16);
    const bgB = parseInt(baseColorHex.slice(5, 7), 16);
    
    doc.setFillColor(bgR, bgG, bgB);
    doc.rect(15, 45, 180, 60, 'F');
    
    doc.setDrawColor(100, 100, 100);
    doc.setLineWidth(0.5);
    doc.rect(15, 45, 180, 60);
    
    const nameText = (selectedData.nameText || 'YOUR NAME').toUpperCase();
    
    const fontMap = {
      'arial': 'helvetica',
      'impact': 'helvetica',
      'times': 'times',
      'courier': 'courier',
      'script': 'times',
      'supermario256': 'helvetica',
      'ransom': 'helvetica',
      'boldstrom': 'helvetica',
      'bloodhunter': 'helvetica',
      'deathbones': 'helvetica',
      'impacted': 'helvetica',
      'applepeach': 'helvetica',
      'wonderbar': 'helvetica',
      'madebytommy': 'helvetica',
      'parryhotter': 'helvetica',
      'luckiestguy': 'helvetica',
      'honeybear': 'helvetica',
      'milker': 'helvetica',
      'wednesday': 'helvetica',
      'attackofmonster': 'helvetica',
      'frank': 'helvetica',
      'crackman': 'helvetica',
      'greenenergy': 'helvetica',
      'moldie': 'helvetica',
      'galantic': 'helvetica',
      'spookyghost': 'helvetica',
      'gameofthrones': 'helvetica',
      'thegodfather': 'helvetica',
      'analogy': 'helvetica',
      'moliga': 'helvetica',
      'candyhunter': 'helvetica'
    };
    
    const sizeMap = {
      'small': 16,
      'medium': 24,
      'large': 32
    };
    
    const pdfFont = fontMap[selectedData.nameFont] || 'helvetica';
    const pdfWeight = (selectedData.nameWeight === 'bold' || selectedData.nameFont === 'impact') ? 'bold' : 'normal';
    const pdfSize = sizeMap[selectedData.nameSize] || 24;
    
    doc.setFont(pdfFont, pdfWeight);
    doc.setFontSize(pdfSize);
    
    const textColorHex = selectedData.nameColor || '#FFFFFF';
    const textR = parseInt(textColorHex.slice(1, 3), 16);
    const textG = parseInt(textColorHex.slice(3, 5), 16);
    const textB = parseInt(textColorHex.slice(5, 7), 16);
    doc.setTextColor(textR, textG, textB);
    
    doc.text(nameText, 105, 75, { align: 'center' });
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    
    doc.setFontSize(14);
    doc.text('Configuration:', 15, 125);
    
    doc.setFontSize(11);
    let yPos = 135;
    
    const fontDisplayMap = {
      'arial': 'Arial',
      'impact': 'Impact', 
      'times': 'Times New Roman',
      'courier': 'Courier',
      'script': 'Script'
    };
    
    const sizeDisplayMap = {
      'small': 'Small (18px)',
      'medium': 'Medium (24px)',
      'large': 'Large (30px)'
    };
    
    doc.text(`Name Text: ${selectedData.nameText || 'N/A'}`, 20, yPos);
    yPos += 8;

    
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    doc.text('Note: Name will be printed on the inside surface of the gumshield', 15, yPos + 20);
    doc.text('for easy identification in locker rooms or during matches.', 15, yPos + 26);
    
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Venneir Limited - Custom Dental Appliances', 15, 285);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 15, 290);
    
    return doc.output('blob');
  }

  // Generate storage case PDF
  function generateStorageCasePDF() {
    return new Promise((resolve, reject) => {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      doc.setFontSize(18);
      doc.text('Selected Storage Case', 15, 15);
      
      if (selectedData.storageCase && selectedData.storageCaseImage) {
        const caseImg = new Image();
        caseImg.crossOrigin = 'anonymous';
        
        caseImg.onload = function() {
          try {
            const imgSize = 100;
            
            const pageWidth = 210;
            const imgX = (pageWidth - imgSize) / 2;
            const imgY = 40;
            
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = caseImg.width;
            canvas.height = caseImg.height;
            ctx.drawImage(caseImg, 0, 0);
            const imgData = canvas.toDataURL('image/png');
            
            doc.addImage(imgData, 'PNG', imgX, imgY, imgSize, imgSize);
            
            const caseName = selectedData.storageCase.charAt(0).toUpperCase() + selectedData.storageCase.slice(1);
            doc.setFontSize(16);
            doc.setFont('helvetica', 'bold');
            const textWidth = doc.getTextWidth(caseName);
            const textX = (pageWidth - textWidth) / 2;
            doc.text(caseName, textX, imgY + imgSize + 15);
            
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(80, 80, 80);
            const note1 = 'This protective storage case will be included with your order.';
            const note2 = 'Value: £12.95 (Included Free)';
            const note1Width = doc.getTextWidth(note1);
            const note2Width = doc.getTextWidth(note2);
            doc.text(note1, (pageWidth - note1Width) / 2, imgY + imgSize + 30);
            doc.text(note2, (pageWidth - note2Width) / 2, imgY + imgSize + 37);
            
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text('Venneir Limited - Custom Dental Appliances', 15, 285);
            doc.text(`Generated: ${new Date().toLocaleString()}`, 15, 290);
            
            resolve(doc.output('blob'));
          } catch (error) {
            reject(error);
          }
        };
        
        caseImg.onerror = function() {
          reject(new Error('Failed to load storage case image'));
        };
        
        caseImg.src = selectedData.storageCaseImage;
      } else {
        reject(new Error('No storage case selected'));
      }
    });
  }

  // Main checkout function
  async function proceedToCheckout() {
    const checkoutBtn = document.getElementById('piranha-next-btn');
    const originalText = checkoutBtn?.textContent;

    try {
      if (checkoutBtn) {
        checkoutBtn.textContent = 'Generating files...';
        checkoutBtn.disabled = true;
      }
      setUploading(true, 'Saving your design', 'Generating order files…');

      // Wait — in real time — for any in-flight image-layer additions to
      // finish so they're present in selectedData.designLayers before the
      // screenshot is taken. Without this, clicking Checkout while an
      // image is still compressing produces a screenshot missing the upload.
      const pending = window.piranhaPendingImagePromises || [];
      if (pending.length > 0) {
        if (checkoutBtn) checkoutBtn.textContent = 'Finishing image upload...';
        setUploading(true, 'Saving your design', 'Finishing last image…');
        await Promise.all(pending.slice());
        if (checkoutBtn) checkoutBtn.textContent = 'Generating files...';
        setUploading(true, 'Saving your design', 'Generating order files…');
      }

    // ── Order file assembly + upload ───────────────────────────────────
    // Every file is uploaded individually so Checkpoint can render the
    // design preview and link to each asset directly, without unpacking a
    // ZIP. Uploads happen in parallel. The full set of {name, url, type,
    // category} is JSON-stringified onto the line item as _Design Files.
    const hasScanFiles = window.piranhaScanFiles && window.piranhaScanFiles.length > 0;
    const timestamp = Date.now();
    const orderRef = `GSB-${timestamp}`;
    let previewImageUrl = '';
    let designFilesManifest = [];

    if (selectedData.designChoice !== 'predesign' ||
        (selectedData.designLayers && selectedData.designLayers.length > 0) ||
        hasScanFiles) {

      // 1. Design preview (PNG) — generated once, used for both the
      //    customer-facing preview and embedded in the layout-plan PDF.
      let previewBlob = null;
      try {
        previewBlob = await generateDesignPreviewBlob();
      } catch (e) {
        console.warn('Design preview generation failed:', e);
      }

      // 2. Layout-plan PDF — embeds the preview + the configuration text.
      let layoutPdfBlob = null;
      try {
        layoutPdfBlob = await generatePreviewPDF(previewBlob);
      } catch (e) {
        console.warn('Layout PDF generation failed:', e);
      }

      // 3. Inside name tag PDF
      let nameTagPdfBlob = null;
      if (selectedData.insideNameTag && selectedData.nameText) {
        try { nameTagPdfBlob = generateInsideTagPDF(); }
        catch (e) { console.warn('Name tag PDF failed:', e); }
      }

      // 4. Storage case PDF
      let storageCasePdfBlob = null;
      if (selectedData.storageCase && selectedData.storageCaseImage) {
        try { storageCasePdfBlob = await generateStorageCasePDF(); }
        catch (e) { console.warn('Storage case PDF failed:', e); }
      }

      // 5. Design image layers — decode dataURLs → Blobs.
      // 6. Design text element PDFs + baked preview PNGs — one of each per
      //    text layer. The preview PNG lets Checkpoint render the customer's
      //    text in the exact font/colour they chose, with no font loading
      //    on its side.
      const designImageBlobs = [];
      const designTextBlobs = [];
      if (selectedData.designLayers) {
        let imageCounter = 1;
        let textCounter = 1;
        for (const layer of selectedData.designLayers) {
          if (layer.type === 'image' && layer.dataURL) {
            try {
              const r = await fetch(layer.dataURL);
              const blob = await r.blob();
              const ext = (blob.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
              designImageBlobs.push({
                blob, ext, index: imageCounter,
                meta: { w: layer.w || null, h: layer.h || null }
              });
              imageCounter++;
            } catch (e) {
              console.warn('Design image layer blob decode failed:', layer.id, e);
            }
          } else if (layer.type === 'text') {
            try {
              const pdfBlob = await generateTextPDF(layer, textCounter);
              let previewBlob = null;
              try { previewBlob = await generateTextPreviewBlob(layer); }
              catch (e) { console.warn('Text preview bake failed:', layer.id, e); }
              const meta = {
                text: layer.text || '',
                font: layer.font || 'Arial',
                size: layer.size || null,
                weight: layer.weight || 'normal',
                color: layer.color || '#000000',
              };
              designTextBlobs.push({ pdfBlob, previewBlob, index: textCounter, meta });
              textCounter++;
            } catch (e) {
              console.warn('Design text PDF failed:', layer.id, e);
            }
          }
        }
      }

      // Build the unified upload list. Each entry:
      //   { blob, name, category, type, size, meta? }
      // size + meta are extra context for Checkpoint and downstream tools.
      const filesToUpload = [];
      const pushFile = (entry) => filesToUpload.push({ size: entry.blob.size, ...entry });

      if (previewBlob) {
        pushFile({ blob: previewBlob, name: `${orderRef}-preview.png`, category: 'preview', type: 'image/png' });
      }
      if (layoutPdfBlob) {
        pushFile({ blob: layoutPdfBlob, name: `${orderRef}-design-layout-plan.pdf`, category: 'layout', type: 'application/pdf' });
      }
      if (nameTagPdfBlob) {
        pushFile({
          blob: nameTagPdfBlob,
          name: `${orderRef}-inside-name-tag.pdf`,
          category: 'name-tag',
          type: 'application/pdf',
          meta: {
            text: selectedData.nameText || '',
            font: selectedData.nameFont || null,
            size: selectedData.nameSize || null,
            color: selectedData.nameColor || null,
          },
        });
      }
      if (storageCasePdfBlob) {
        pushFile({
          blob: storageCasePdfBlob,
          name: `${orderRef}-storage-case.pdf`,
          category: 'storage-case',
          type: 'application/pdf',
          meta: {
            case: selectedData.storageCase || null,
            imageUrl: selectedData.storageCaseImage || null,
          },
        });
      }
      if (hasScanFiles) {
        window.piranhaScanFiles.forEach((file, i) => {
          const safeName = file.name.replace(/[^a-zA-Z0-9_.-]/g, '_');
          pushFile({
            blob: file,
            name: `${orderRef}-scan-${i + 1}-${safeName}`,
            category: 'scan',
            type: file.type || 'application/octet-stream',
            meta: { originalName: file.name },
          });
        });
      }
      designImageBlobs.forEach(d => {
        pushFile({
          blob: d.blob,
          name: `${orderRef}-design-image-${d.index}.${d.ext}`,
          category: 'design-image',
          type: d.blob.type,
          meta: d.meta,
        });
      });
      designTextBlobs.forEach(d => {
        const baseName = `${orderRef}-design-text-${d.index}`;
        pushFile({
          blob: d.pdfBlob,
          name: `${baseName}.pdf`,
          category: 'design-text',
          type: 'application/pdf',
          meta: d.meta,
        });
        if (d.previewBlob) {
          pushFile({
            blob: d.previewBlob,
            name: `${baseName}-preview.png`,
            category: 'design-text-preview',
            type: 'image/png',
            meta: { ...d.meta, parent: `design-text-${d.index}` },
          });
        }
      });

      // Font files for every unique family the customer used. Pulled
      // from _piranhaFontCache (populated by buildInlineFontFaceCSS
      // during the text-preview bake) so we ship the same bytes the
      // PNG was rendered against. The lab can download the TTF/OTF and
      // install if they need to reproduce by hand.
      const uniqueFonts = new Set(
        designTextBlobs
          .map(d => String(d.meta?.font || '').trim())
          .filter(Boolean)
      );
      for (const family of uniqueFonts) {
        const cached = _piranhaFontCache.get(family.toLowerCase());
        if (!cached || !cached.dataURL) continue;
        try {
          const r = await fetch(cached.dataURL);
          const blob = await r.blob();
          const ext = String(cached.format || '').toLowerCase() === 'opentype' ? 'otf' : 'ttf';
          const safe = family.replace(/[^a-zA-Z0-9_-]/g, '_');
          pushFile({
            blob,
            name: `${orderRef}-font-${safe}.${ext}`,
            category: 'font-file',
            type: blob.type || `font/${ext}`,
            meta: { family, format: cached.format || 'truetype' },
          });
        } catch (e) {
          console.warn('[piranha] could not bundle font file', family, e);
        }
      }

      if (checkoutBtn) {
        checkoutBtn.textContent = `Uploading ${filesToUpload.length} file${filesToUpload.length === 1 ? '' : 's'}...`;
      }
      setUploading(
        true,
        'Saving your design',
        `Uploading ${filesToUpload.length} file${filesToUpload.length === 1 ? '' : 's'} to your order…`
      );

      // Upload in parallel. Failures bubble up — the customer sees the
      // standard "upload failed" message and we don't ship a half-order.
      // Every metadata field on the entry is preserved into the final
      // manifest (size, meta, category) for Checkpoint to render against.
      const uploaded = await Promise.all(
        filesToUpload.map(f =>
          uploadOrderFiles(f.blob, f.name).then(url => {
            const entry = { name: f.name, url, category: f.category, type: f.type, size: f.size };
            if (f.meta) entry.meta = f.meta;
            return entry;
          })
        )
      );

      designFilesManifest = uploaded;
      previewImageUrl = uploaded.find(f => f.category === 'preview')?.url || '';
    }

if (checkoutBtn) {
checkoutBtn.textContent = 'Adding to cart...';
}

let items = [];

const impressionMethodMap = {
'impression-kit': 'Free Impression Kit',
'dental-scan': 'Digital Dental Scan',
'own-models': 'Your Own Models',
  'gym-kit': 'Gym Impression Kit'  // ← ADD THIS LINE
};

const gumshieldVariantId = VARIANT_IDS.gumshield[selectedData.impressionMethod];
const itemProperties = {
'Impression Method': impressionMethodMap[selectedData.impressionMethod] || 'Free Impression Kit',
'Storage Case': selectedData.storageCase || 'Not selected',
'Inside Name Tag': selectedData.insideNameTag ? selectedData.nameText : 'No',
'Express Production': selectedData.expressDelivery ? 'Yes' : 'No'
};

// Add design-specific properties
if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesign) {
itemProperties['Design Type'] = 'Pre-designed: ' + selectedData.selectedPredesign;
itemProperties['Prebuilt Design'] = selectedData.selectedPredesign;
if (selectedData.selectedPredesignImage) {
  itemProperties['_Design Preview Image'] = selectedData.selectedPredesignImage;
}
if (selectedData.baseColour) {
  itemProperties['Base Colour'] = selectedData.baseColour;
  if (selectedData.baseColourHex) itemProperties['Base Colour Hex'] = selectedData.baseColourHex;
  if (selectedData.complexDesignImageUrl) itemProperties['Complex Design Image'] = selectedData.complexDesignImageUrl;
}
} else if (selectedData.designChoice === 'custom') {
itemProperties['Design Type'] = 'Custom Design';
itemProperties['Base Colour'] = selectedData.baseColour || 'Not selected';
if (selectedData.baseColourHex) itemProperties['Base Colour Hex'] = selectedData.baseColourHex;
if (selectedData.complexDesignImageUrl) itemProperties['Complex Design Image'] = selectedData.complexDesignImageUrl;
}

if (hasScanFiles) {
itemProperties['Dental Scans'] = `${window.piranhaScanFiles.length} file${window.piranhaScanFiles.length === 1 ? '' : 's'} uploaded`;
}
if (previewImageUrl) {
itemProperties['_Design Preview Image'] = previewImageUrl;
}
if (designFilesManifest.length > 0) {
itemProperties['_Design Files'] = JSON.stringify(designFilesManifest);
}

items.push({
id: gumshieldVariantId,
quantity: 1,
properties: itemProperties
});
      
      if (selectedData.backupQuantity > 0) {
  for (let i = 0; i < selectedData.backupQuantity; i++) {
    const backupProperties = {
      'Type': 'Backup Gumshield (50% off)',
      'Impression Method': impressionMethodMap[selectedData.impressionMethod] || 'Free Impression Kit'
    };
    
    // Add design-specific properties for backup
    if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesign) {
      backupProperties['Design Type'] = 'Pre-designed: ' + selectedData.selectedPredesign;
    } else if (selectedData.designChoice === 'custom') {
      backupProperties['Design Type'] = 'Custom Design';
      backupProperties['Base Colour'] = selectedData.baseColour || 'Not selected';
      if (selectedData.baseColourHex) backupProperties['Base Colour Hex'] = selectedData.baseColourHex;
      if (previewImageUrl) {
        backupProperties['_Design Preview Image'] = previewImageUrl;
      }
      if (designFilesManifest.length > 0) {
        backupProperties['_Design Files'] = JSON.stringify(designFilesManifest);
      }
    }
    
    items.push({
      id: gumshieldVariantId,
      quantity: 1,
      properties: backupProperties
    });
  }
}

     // Express production is now included free - don't add the paid variant
// if (selectedData.expressDelivery) {
//   items.push({
//     id: VARIANT_IDS.addons.express,
//     quantity: 1
//   });
// }
      
      const nameTagQuantity = selectedData.insideNameTag ? 1 : 0;
      
      if (selectedData.insideNameTag) {
        items.push({
          id: VARIANT_IDS.addons.nameTag,
          quantity: 1,
          properties: {
            'Name Text': selectedData.nameText || '',
            'Font': selectedData.nameFont || 'arial',
            'Weight': selectedData.nameWeight || 'normal',
            'Size': selectedData.nameSize || 'medium',
            'Color': selectedData.nameColor || '#FFFFFF'
          }
        });
      }
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      });
      
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      
     const orderAttributes = {
  'Order Type': 'Custom Gumshield',
  'Requires Customization': selectedData.designChoice === 'custom' ? 'Yes' : 'No',
  'Storage Case': selectedData.storageCase || 'Not selected',
  'Delivery Speed': selectedData.expressDelivery ? 'Express (2 Days)' : 'Standard (7 days)',
  'Inside Name Tag': selectedData.insideNameTag ? `Yes: ${selectedData.nameText} (+£${pricing.nameTag * nameTagQuantity})` : 'No',
  'Backup Gumshields': selectedData.backupQuantity > 0 ? `Yes: ${selectedData.backupQuantity}x (£${(pricing.base * 0.5 * selectedData.backupQuantity).toFixed(2)})` : 'No',
  'Design Layers': selectedData.designLayers ? selectedData.designLayers.length : 0,
  'Custom Images': selectedData.designLayers ? selectedData.designLayers.filter(l => l.type === 'image').length : 0,
  'Text Elements': selectedData.designLayers ? selectedData.designLayers.filter(l => l.type === 'text').length : 0
};

// Add design-specific attributes
if (selectedData.designChoice === 'predesign' && selectedData.selectedPredesign) {
  orderAttributes['Design Type'] = 'Pre-designed';
  orderAttributes['Prebuilt Design'] = selectedData.selectedPredesign;
  orderAttributes['_Predesign Image'] = selectedData.selectedPredesignImage || '';
} else if (selectedData.designChoice === 'custom') {
  orderAttributes['Design Type'] = selectedData.complexDesign ? 'Complex Custom Design' : 'Custom Design';
  orderAttributes['Base Colour'] = selectedData.baseColour || 'Not selected';
  if (previewImageUrl) {
    orderAttributes['_Design Preview Image'] = previewImageUrl;
  }
  if (designFilesManifest.length > 0) {
    orderAttributes['_Design Files'] = JSON.stringify(designFilesManifest);
  }
} else {
  orderAttributes['Design Type'] = 'Base Colour Only';
  orderAttributes['Base Colour'] = selectedData.baseColour || 'Not selected';
}
      
      
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: orderAttributes
        })
      });
      
      const totalGumshields = 1 + (selectedData.backupQuantity || 0);
      const discountCodes = {
        2: 'MULTI-TWO',
        3: 'MULTI-THREE',
        4: 'MULTI-FOUR',
        5: 'MULTI-FIVE'
      };

      // Multi-quantity discount wins when applicable (better customer
      // saving). Otherwise apply the gym-kit discount if relevant.
      let discountCode = discountCodes[totalGumshields];
      if (!discountCode && selectedData.impressionMethod === 'gym-kit') {
        discountCode = GYM_KIT_DISCOUNT_CODE;
      }
      
      // Build checkout URL with preserved parameters
      const checkoutParams = new URLSearchParams();
      
      // Add original URL parameters (affiliate tracking, etc.)
      Object.keys(affiliateParams).forEach(key => {
        checkoutParams.set(key, affiliateParams[key]);
      });
      
      // Add discount code if applicable
      if (discountCode) {
        checkoutParams.set('discount', discountCode);
      }
      
      setUploading(true, 'Redirecting to checkout', 'Hang tight…');

      // Redirect with all parameters
      const checkoutUrl = checkoutParams.toString()
        ? `/checkout?${checkoutParams.toString()}`
        : '/checkout';
      window.location.href = checkoutUrl;

    } catch (error) {
  setUploading(false);
  console.error('Checkout error:', error);
  
  let errorMessage = 'Error processing order. ';
  
  if (error.message.includes('File size too large')) {
    const match = error.message.match(/Got (\d+)\. Maximum is (\d+)/);
    if (match) {
      const currentSizeMB = (parseInt(match[1]) / 1048576).toFixed(1);
      const maxSizeMB = (parseInt(match[2]) / 1048576).toFixed(1);
      errorMessage = `Your design files are too large (${currentSizeMB}MB). The maximum size is ${maxSizeMB}MB.\n\nPlease remove some images or use smaller file sizes and try again.`;
    } else {
      errorMessage = 'Your design files are too large. Please use smaller images and try again.';
    }
  } else if (error.message.includes('atob')) {
    errorMessage += 'There was an issue with an uploaded image. Please try removing and re-adding your images.';
  } else if (error.message.includes('Upload failed') || error.message.includes('too_large')) {
    errorMessage += 'File upload failed. Please check your internet connection and try again.';
  } else {
    errorMessage += error.message;
  }
  
  showPiranhaToast(errorMessage, 6000);
  
  if (checkoutBtn) {
    checkoutBtn.textContent = originalText;
    checkoutBtn.disabled = false;
  }
}
  }

  // Handle canvas push-down for flyouts on mobile
function handleFlyoutCanvasPush(isOpen) {
  const canvasContainer = document.getElementById('piranha-canvas-container');
  if (!canvasContainer) return;
  
  // Only apply on mobile/tablet
  if (window.innerWidth <= 768) {
    if (isOpen) {
      canvasContainer.classList.add('flyout-active');
    } else {
      canvasContainer.classList.remove('flyout-active');
    }
  }
}
  

// ========== GALLERY JAVASCRIPT - FIXED ==========
  const galleryData = {
    'teeth': {
      name: 'Teeth',
      subcategories: {
        'fangs': {
          name: 'Fangs',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/fangs.png?v=1762963497', name: 'Fangs' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Bloody_Vampire_Teeth.png?v=1762963507', name: 'Bloody Vampire Teeth' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Silver_Vampire_Teeth.png?v=1762963507', name: 'Silver Vampire Teeth' }
          ]
        },
        'messed-up': {
          name: 'Messed Up',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/missing-tooth.png?v=1762963496', name: 'Missing Tooth' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Red_Rotten_Teeth.png?v=1762963508', name: 'Red Rotten Teeth' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/funky_teeth.png?v=1762963497', name: 'Funky Teeth' }
          ]
        },
        'bling': {
          name: 'Bling',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Gold_Grillz.png?v=1762963508', name: 'Gold Grillz' }
          ]
        },
        'sharp': {
          name: 'Sharp & Spiky',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/spikey-teeth-1.png?v=1762963497', name: 'Spikey Teeth' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Sharp_Teeth.png?v=1762963497', name: 'Sharp Teeth' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/teeth.png?v=1762963497', name: 'Teeth' }
          ]
        }
      }
    },
    'flags': {
      name: 'Flags',
      subcategories: {
        'large-flags': {
          name: 'Large Flags',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/slovakia_flag.png?v=1762963542', name: 'Slovakia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/spain_flag.png?v=1762963543', name: 'Spain' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/suriname_flag.png?v=1762963542', name: 'Suriname' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/sweden_flag.png?v=1762963542', name: 'Sweden' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/switzerland_flag.png?v=1762963542', name: 'Switzerland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/syria_flag.png?v=1762963543', name: 'Syria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/tunisia_flag.png?v=1762963542', name: 'Tunisia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/ukraine_flag.png?v=1762963542', name: 'Ukraine' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/turkey_flag.png?v=1762963542', name: 'Turkey' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/netherlands_flag.png?v=1762963550', name: 'Netherlands' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/north_macedonia_flag.png?v=1762963549', name: 'North Macedonia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/poland_flag.png?v=1762963549', name: 'Poland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/poland_no_insignia_flag.png?v=1762963550', name: 'Poland (No Insignia)' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/portugal_flag.png?v=1762963550', name: 'Portugal' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/republic_congo_flag.png?v=1762963550', name: 'Republic of Congo' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/romania_flag.png?v=1762963550', name: 'Romania' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/russia_flag.png?v=1762963550', name: 'Russia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/senegal_flag.png?v=1762963550', name: 'Senegal' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/serbia_flag.png?v=1762963550', name: 'Serbia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/germany_flag.png?v=1762963557', name: 'Germany' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/greece_flag.png?v=1762963557', name: 'Greece' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/hungary_flag.png?v=1762963557', name: 'Hungary' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/iran_flag.png?v=1762963557', name: 'Iran' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/iraq_flag.png?v=1762963557', name: 'Iraq' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/italy_flag.png?v=1762963556', name: 'Italy' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/kosovo_flag.png?v=1762963557', name: 'Kosovo' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/kurdistan_flag.png?v=1762963557', name: 'Kurdistan' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/mali_flag.png?v=1762963557', name: 'Mali' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/morocco_flag.png?v=1762963556', name: 'Morocco' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/bosnia_flag.png?v=1762963563', name: 'Bosnia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/bulgaria_flag.png?v=1762963563', name: 'Bulgaria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/chechenya_flag.png?v=1762963563', name: 'Chechnya' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/croatia_flag.png?v=1762963563', name: 'Croatia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/cote_d_ivoire_flag.png?v=1762963563', name: 'Côte d\'Ivoire' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/congo_flag.png?v=1762963563', name: 'Congo' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/denmark_flag.png?v=1762963563', name: 'Denmark' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/finland_flag.png?v=1762963563', name: 'Finland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/france_flag.png?v=1762963564', name: 'France' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/georgia_flag.png?v=1762963563', name: 'Georgia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/afghanistan_flag.png?v=1762963568', name: 'Afghanistan' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/albania_flag.png?v=1762963568', name: 'Albania' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/algeria_flag.png?v=1762963568', name: 'Algeria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/austria_flag.png?v=1762963568', name: 'Austria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/belgium_flag.png?v=1762963569', name: 'Belgium' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/scotland_e828b38a-0f38-4a6e-81c5-0581a875627c.png?v=1762964362', name: 'Scotland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/ireland_110cfd33-c1b9-48f4-933f-e455aea3add0.png?v=1762964361', name: 'Ireland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/britain_64fd2cfc-6220-4812-b1ad-70eb4e729303.png?v=1762964361', name: 'Britain' }
          ]
        },
        'flag-icons': {
          name: 'Flag Icons',
          images: [
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/congo_democratic_republic.png?v=1762963650', name: 'Congo DR' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/chechnya.png?v=1762963650', name: 'Chechnya' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/bulgaria.png?v=1762963650', name: 'Bulgaria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/bosnia_herzegovina.png?v=1762963650', name: 'Bosnia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/belgium_civil.png?v=1762963650', name: 'Belgium' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/austria.png?v=1762963649', name: 'Austria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/algeria_2.png?v=1762963650', name: 'Algeria Alt' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/algeria_1.png?v=1762963650', name: 'Algeria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/albania.png?v=1762963649', name: 'Albania' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/afghanistan_2013-2021.png?v=1762963650', name: 'Afghanistan' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/hungary.png?v=1762963658', name: 'Hungary' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/greece.png?v=1762963657', name: 'Greece' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/germany.png?v=1762963657', name: 'Germany' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/georgia.png?v=1762963657', name: 'Georgia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/france_2024.png?v=1762963657', name: 'France' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/finland.png?v=1762963657', name: 'Finland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/denmark.png?v=1762963657', name: 'Denmark' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/croatia.png?v=1762963657', name: 'Croatia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/cote_d_ivoire.png?v=1762963657', name: 'Côte d\'Ivoire' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/congo_republic.png?v=1762963657', name: 'Congo' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/netherlands.png?v=1762963664', name: 'Netherlands' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/morocco.png?v=1762963664', name: 'Morocco' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/mali.png?v=1762963664', name: 'Mali' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/kurdistan_2.png?v=1762963664', name: 'Kurdistan Alt' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/kurdistan_1.png?v=1762963664', name: 'Kurdistan' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/kosovo.png?v=1762963664', name: 'Kosovo' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/italy.png?v=1762963664', name: 'Italy' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/iraq.png?v=1762963664', name: 'Iraq' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/iran.png?v=1762963664', name: 'Iran' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/suriname.png?v=1762963671', name: 'Suriname' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/spain.png?v=1762963671', name: 'Spain' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/slovakia.png?v=1762963671', name: 'Slovakia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/senegal.png?v=1762963671', name: 'Senegal' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/russia.png?v=1762963671', name: 'Russia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/romania.png?v=1762963672', name: 'Romania' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/portugal_official.png?v=1762963671', name: 'Portugal' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/poland.png?v=1762963671', name: 'Poland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/poland_with_coat_of_arms.png?v=1762963671', name: 'Poland (Coat)' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/north_macedonia.png?v=1762963671', name: 'North Macedonia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/ukraine.png?v=1762963676', name: 'Ukraine' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/turkey.png?v=1762963676', name: 'Turkey' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/tunisia.png?v=1762963676', name: 'Tunisia' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/syria_2025.png?v=1762963676', name: 'Syria' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/switzerland.png?v=1762963676', name: 'Switzerland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/sweden.png?v=1762963677', name: 'Sweden' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Britain.png?v=1762964338', name: 'Britain' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Ireland.png?v=1762964338', name: 'Ireland' },
            { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Scotland.png?v=1762964338', name: 'Scotland' }
          ]
        }
      }
    },
'patterns': {
  name: 'Patterns',
  images: [
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Camo.png?v=1762963497', name: 'Camo' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Tie_Dye.png?v=1762963497', name: 'Tie Dye' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Camo_II.png?v=1762963507', name: 'Camo II' }
  ]
},
'effects': {
  name: 'Effects',
  images: [
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/BLAM.png?v=1762963497', name: 'BLAM!' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Barb_Wire.png?v=1762963508', name: 'Barb Wire' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/blood_splatters.png?v=1762963507', name: 'Blood Splatters' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/blood_splatter.png?v=1762963508', name: 'Blood Splatter' }
  ]
},
'cultural': {
  name: 'Cultural',
  images: [
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/Muay_Thai.png?v=1762963497', name: 'Muay Thai' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/japan_demons.png?v=1762963508', name: 'Japan Demons' },
    { url: 'https://cdn.shopify.com/s/files/1/0872/8651/4000/files/mariachi_skull.png?v=1762963508', name: 'Mariachi Skull' }
  ]
}
  };

  let currentPath = { main: null, sub: null };

  function openGalleryModal() {
    const overlay = document.getElementById('piranha-gallery-modal-overlay');
    overlay.classList.add('active');
    document.body.classList.add('piranha-modal-open');
    currentPath = { main: null, sub: null };
    showMainCategories();
  }

  function closeGalleryModal() {
    const overlay = document.getElementById('piranha-gallery-modal-overlay');
    overlay.classList.remove('active');
    document.body.classList.remove('piranha-modal-open');
    currentPath = { main: null, sub: null };
  }

  function updateBreadcrumbs() {
    const breadcrumbs = document.getElementById('piranha-gallery-breadcrumbs');
    let html = '<span class="piranha-breadcrumb piranha-breadcrumb-all">All Categories</span>';
    
    if (currentPath.main) {
      const mainName = galleryData[currentPath.main].name;
      const isActive = !currentPath.sub;
      html += `<span class="piranha-breadcrumb piranha-breadcrumb-main ${isActive ? 'piranha-breadcrumb-active' : ''}">${mainName}</span>`;
    }
    
    if (currentPath.sub) {
      const subName = galleryData[currentPath.main].subcategories[currentPath.sub].name;
      html += `<span class="piranha-breadcrumb piranha-breadcrumb-sub piranha-breadcrumb-active">${subName}</span>`;
    }
    
    breadcrumbs.innerHTML = html;
    
    // Add click handlers
    const allCrumb = breadcrumbs.querySelector('.piranha-breadcrumb-all');
    if (allCrumb) {
      allCrumb.addEventListener('click', showMainCategories);
    }
    
    const mainCrumb = breadcrumbs.querySelector('.piranha-breadcrumb-main');
    if (mainCrumb && currentPath.main) {
      mainCrumb.addEventListener('click', () => showSubcategories(currentPath.main));
    }
  }

function showMainCategories() {
  currentPath = { main: null, sub: null };
  const categoriesView = document.getElementById('piranha-gallery-categories');
  const imagesView = document.getElementById('piranha-gallery-images-grid');
  
  categoriesView.style.display = 'flex';
  imagesView.style.display = 'none';
  categoriesView.innerHTML = '';
  
  Object.keys(galleryData).forEach(categoryKey => {
    const category = galleryData[categoryKey];
    const card = document.createElement('div');
    card.className = 'piranha-gallery-category-card';
    
    // Check if category has subcategories or direct images
    const hasSubcategories = category.subcategories && Object.keys(category.subcategories).length > 0;
    
    card.innerHTML = `
      <h4>${category.name}</h4>
      ${hasSubcategories ? `<span class="piranha-gallery-category-chevron">
        <svg role="presentation" focusable="false" width="5" height="8" viewBox="0 0 5 8">
          <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
        </svg>
      </span>` : ''}
    `;
    
    // Prevent touch conflicts
    card.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (hasSubcategories) {
        showSubcategories(categoryKey);
      } else {
        // Go directly to images
        showDirectImages(categoryKey);
      }
    });
    
    categoriesView.appendChild(card);
  });
  
  updateBreadcrumbs();
}

 function showSubcategories(categoryKey) {
  currentPath = { main: categoryKey, sub: null };
  const categoriesView = document.getElementById('piranha-gallery-categories');
  const imagesView = document.getElementById('piranha-gallery-images-grid');
  
  categoriesView.style.display = 'flex';
  imagesView.style.display = 'none';
  categoriesView.innerHTML = '';
  
  const category = galleryData[categoryKey];
  Object.keys(category.subcategories).forEach(subKey => {
    const subcategory = category.subcategories[subKey];
    const card = document.createElement('div');
    card.className = 'piranha-gallery-category-card';
    card.innerHTML = `
      <h4>${subcategory.name}</h4>
      <span class="piranha-gallery-category-chevron">
        <svg role="presentation" focusable="false" width="5" height="8" viewBox="0 0 5 8">
          <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
        </svg>
      </span>
    `;
    
    // Prevent touch conflicts
    card.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      showImages(categoryKey, subKey);
    });
    
    categoriesView.appendChild(card);
  });
  
  updateBreadcrumbs();
}


function showDirectImages(categoryKey) {
  currentPath = { main: categoryKey, sub: null };
  const categoriesView = document.getElementById('piranha-gallery-categories');
  const imagesView = document.getElementById('piranha-gallery-images-grid');
  
  categoriesView.style.display = 'none';
  imagesView.style.display = 'grid';
  imagesView.innerHTML = '';
  
  const category = galleryData[categoryKey];
  
  // Sort images alphabetically by name
  const sortedImages = [...category.images].sort((a, b) => 
    a.name.localeCompare(b.name)
  );
  
  sortedImages.forEach(image => {
    const imageCard = document.createElement('div');
    imageCard.className = 'piranha-gallery-image-card';
    imageCard.innerHTML = `
      <div class="piranha-gallery-image-wrapper">
        <div class="piranha-image-loading"></div>
        <img data-src="${image.url}" alt="${image.name}">
      </div>
      <div class="piranha-gallery-image-name">${image.name}</div>
    `;
    
    // Prevent touch conflicts on image selection
    imageCard.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      selectImage(image.url);
    });
    
    imagesView.appendChild(imageCard);
  });
  
  // Implement lazy loading
  lazyLoadImages();
  updateBreadcrumbs();
}

 function showImages(categoryKey, subcategoryKey) {
  currentPath = { main: categoryKey, sub: subcategoryKey };
  const categoriesView = document.getElementById('piranha-gallery-categories');
  const imagesView = document.getElementById('piranha-gallery-images-grid');
  
  categoriesView.style.display = 'none';
  imagesView.style.display = 'grid';
  imagesView.innerHTML = '';
  
  const subcategory = galleryData[categoryKey].subcategories[subcategoryKey];
  
  // Sort images alphabetically by name
  const sortedImages = [...subcategory.images].sort((a, b) => 
    a.name.localeCompare(b.name)
  );
  
  sortedImages.forEach(image => {
    const imageCard = document.createElement('div');
    imageCard.className = 'piranha-gallery-image-card';
    imageCard.innerHTML = `
      <div class="piranha-gallery-image-wrapper">
        <div class="piranha-image-loading"></div>
        <img data-src="${image.url}" alt="${image.name}">
      </div>
      <div class="piranha-gallery-image-name">${image.name}</div>
    `;
    
    // Prevent touch conflicts on image selection
    imageCard.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      selectImage(image.url);
    });
    
    imagesView.appendChild(imageCard);
  });
  
  // Implement lazy loading
  lazyLoadImages();
  updateBreadcrumbs();
}

  function lazyLoadImages() {
    const imageElements = document.querySelectorAll('.piranha-gallery-image-wrapper img[data-src]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const loadingSpinner = img.previousElementSibling;
          
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
          
          img.onload = () => {
            img.classList.add('loaded');
            if (loadingSpinner) loadingSpinner.style.display = 'none';
          };
          
          img.onerror = () => {
            if (loadingSpinner) loadingSpinner.style.display = 'none';
            console.error('Failed to load image:', img.src);
          };
          
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px'
    });
    
    imageElements.forEach(img => imageObserver.observe(img));
  }

  function selectImage(imageUrl) {
  closeGalleryModal();
  
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = async function() {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, img.width, img.height);
    let hasTransparency = false;
    for (let i = 3; i < imageData.data.length; i += 4) {
      if (imageData.data[i] < 255) { hasTransparency = true; break; }
    }

    const dataURL = hasTransparency
      ? canvas.toDataURL('image/png')
      : canvas.toDataURL('image/jpeg', 0.85);

    if (typeof addImageLayer === 'function') {
      // Gallery designs full-bleed the printable area (no grey gaps at the edges).
      try { await addImageLayer(dataURL, { cover: true }); }
      catch (err) { console.error('Gallery image add failed:', err); }
    } else {
      console.error('addImageLayer function not found');
    }
  };
  img.onerror = function() {
    showPiranhaToast('Failed to load image. Please try again.');
  };
  img.src = imageUrl;
}

  // Use event delegation on document so these handlers work regardless of
  // when the gallery markup is parsed/injected. The external script tag runs
  // synchronously mid-document (before the modal HTML below it is parsed), so
  // binding directly to the close button / overlay here would silently no-op
  // because getElementById returns null at execution time.
  (function () {
    document.addEventListener('click', function (e) {
      if (e.target.closest('#piranha-gallery-btn')) {
        openGalleryModal();
        return;
      }
      if (e.target.closest('#piranha-gallery-modal-close')) {
        closeGalleryModal();
        return;
      }
      if (e.target.id === 'piranha-gallery-modal-overlay') {
        closeGalleryModal();
      }
    });
  })();
  // ========== GALLERY JAVASCRIPT - END ==========


})();

